import { defineStore, getActivePinia } from "pinia";
import { ref, nextTick } from "vue";
import tools from "@/utils/tools.js";
import globalConfig, {
  chinaAppName,
  ModuleOpenStateControl,
  getPipeReadableFlowUrl,
} from "@/config/config.js";
import { openCreditDialog } from "@/page/credits/addCreditsDialog.js";

import { baseUrl } from "@/config/apiConfig.js";

import feedListApi from "@/api/api/feedListApi.js";
import editorApi from "@/api/api/apiEditor.js";
import { releaseSong } from "@/api/api/apiStore.js";
import sseGenerateApi from "@/api/api/apiSse.js";
import {
  getProducts,
  checkFirstPurchase,
  manageSubscription,
  getInvitePop,
} from "@/api/api/apiCredit.js";
import ShowInviteDialog from "@/components/inviteDialog/inviteDialog.js";

import message from "@/components/functionCallComponent/message.jsx";
import { showActionDialog } from "@/components/functionCallComponent/action/action.js";

import objectStorage, {
  getObjectStorageFullUrl,
} from "@/lib/objectStorage/objectStorage.js";

import useUserDataStore from "@/store/userDataStore.js";

import useDraftDataStore from "./draftDataStore.js";
import useLyricDataStore from "./lyricDataStore.js";
import useMuseDataStore from "./museDataStore.js";
import userReferMusicStore from "./referMusicStore.js";
import useGlobalPlayDataStore from "@/store/globalPlayDataStore.js";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useStoreDetailData from "@/store/storeDetail/storeDetailDataStore.js";
import usePromptDataStore from "@/store/create/promptDataStore.js";
import useCreateEasyModeStore from "@/store/create/createEasyModeStore.js";
import useModelDataStore from "@/store/model/modelDataStore.js"

import useBgmCreateEasyModeStore from "@/store/create/bgmCreateEasyModeStore.js";
import useGlobalUserStateStore from "@/store/globalUserStateStore.js";

import useBgmReferMusicStore from "@/store/create/bgmReferMusicStore.js";

import { firebaseUtils } from "@/utils/analytic/firebaseUtils.js";
// const draftDataStore = useDraftDataStore();
// const lyricDataStore = useLyricDataStore();
// const museDataStore = useMuseDataStore();
// const referMusicStore = userReferMusicStore();
// const promptDataStore = usePromptDataStore();
// const createEasyModeStore = useCreateEasyModeStore();

// const bgmReferMusicStore = useBgmReferMusicStore();
// const bgmCreateEasyModeStore = useBgmCreateEasyModeStore();
// const globalUserStateStore = useGlobalUserStateStore();
const FeedListStoreApiMap = {
  mysong_true: feedListApi.getFilterFeedList,
  mysong_false: feedListApi.getFeedList,

  likemysong_true: feedListApi.getFilterFeedList,
  likemysong_false: feedListApi.getFilterFeedList,

  dislikemysong_true: feedListApi.getFilterFeedList,
  dislikemysong_false: feedListApi.getFilterFeedList,

  createdresult_true: feedListApi.getFilterFeedList,
  createdresult_false: feedListApi.getFeedList,

  publishedmysong_true: feedListApi.getFilterFeedList,
  publishedmysong_false: feedListApi.getFilterFeedList,
  libraryListRenderTypeScamp: null
}

const useFeedListStore = defineStore({
  id: "FeedListStore",
  state: () => {
    return {
      TabDataSuffixLists: [
        "createdresult",
        "likemysong",
        "dislikemysong",
        "mysong",
        "publishedmysong",
      ],
      TabDataSuffixMap: {
        mysong: "mysong",
        likemysong: "likemysong",
        dislikemysong: "dislikemysong",
        createdresult: "createdresult",
        publishedmysong: "publishedmysong",
      },


      feedlist_createdresult: [],
      total_createdresult: 0,
      loadMoreId_createdresult: "",
      isloading_createdresult: true,
      hasInit_createdresult: false,
      hasMore_createdresult: false,

      feedlist_likemysong: [],
      total_likemysong: 0,
      loadMoreId_likemysong: "",
      isloading_likemysong: true,
      hasInit_likemysong: false,
      hasMore_likemysong: false,

      feedlist_dislikemysong: [],
      total_dislikemysong: 0,
      loadMoreId_dislikemysong: "",
      isloading_dislikemysong: true,
      hasInit_dislikemysong: false,
      hasMore_dislikemysong: false,

      feedlist_mysong: [],
      total_mysong: 0,
      loadMoreId_mysong: "",
      isloading_mysong: true,
      hasInit_mysong: false,
      hasMore_mysong: false,

      feedlist_publishedmysong: [],
      total_publishedmysong: 0,
      loadMoreId_publishedmysong: "",
      isloading_publishedmysong: true,
      hasInit_publishedmysong: false,
      hasMore_publishedmysong: false,

      refFeedList: null,

      curSseConnectIdMap: {},
      curGenerateFeedIdList: [],
      sseGeneratingMap: {},
      curGenerateFeedCount: 0,
      curGeneratingFeedIdList: [],
      sseGeneratingConnIdMap: {},

      generating: false,
      initGenerateFeedData: null,

      vipTipVisible: true,
      mysongLastTab: "mysong",
      release: {
        showReleaseModal: false,
        showReleaseFormModal: false,
        showReleaseResultModal: false,
        showReleaseFailModal: false,
        failReason:
          "Reason：Here is the content，here is the content, here is the content",
        reReleaseCallback: () => { },
        release_info: null,
        item: null,
        pitem: null,
      },

      generateStepThinkProcessDataMap: {

      },
      isAwayCloseSubScribeCard: false,
      libraryListRenderTypeScamp: null
    };
  },
  actions: {
    setMysongTab(tab) {
      this.mysongLastTab = tab;
    },
    setVipTipVisible(visible) {
      this.vipTipVisible = visible;
    },
    clearData() {
      this.feedlist_createdresult = [];
      this.loadMoreId_createdresult = "";
      this.isloading_createdresult = true;
      this.hasInit_createdresult = false;
      this.hasMore_createdresult = false;

      this.feedlist_likemysong = [];
      this.loadMoreId_likemysong = "";
      this.isloading_likemysong = true;
      this.hasInit_likemysong = false;
      this.hasMore_likemysong = false;

      this.feedlist_dislikemysong = [];
      this.loadMoreId_dislikemysong = "";
      this.isloading_dislikemysong = true;
      this.hasInit_dislikemysong = false;
      this.hasMore_dislikemysong = false;


      this.feedlist_mysong = [];
      this.loadMoreId_mysong = "";
      this.isloading_mysong = true;
      this.hasInit_mysong = false;
      this.hasMore_mysong = false;

      this.curSseConnectIdMap = {};
      this.curGenerateFeedIdList = [];
      this.curGenerateFeedCount = 0;
      this.sseGeneratingConnIdMap = {};
      Object.keys(this.sseGeneratingMap).forEach((key) => {
        this.sseGeneratingMap[key]?.abort();
      });
      this.sseGeneratingMap = {};
      this.curGeneratingFeedIdList = [];
      this.generating = this.getIsGenerating();
      this.generateStepThinkProcessDataMap = {};
    },

    closeThinkingProcessCard(pitem) {
      delete this.generateStepThinkProcessDataMap[pitem.feed_id]
      if (
        this['feedlist_createdresult'].some((feedItem) => {
          if (feedItem.feed_id == pitem.feed_id) {
            feedItem.content = null;
            feedItem.with_thinking_process = false;
            return true;
          }
        })) {
        this['feedlist_createdresult'] = [].concat(this['feedlist_createdresult']);
      }

    },

    initFeedData(data, params) {
      const { listRenderType } = params;
      this[`feedlist_${this.TabDataSuffixMap[listRenderType]}`] = data?.list ?? [];
      this[`total_${this.TabDataSuffixMap[listRenderType]}`] = data?.total ?? 0;
      if (this.initGenerateFeedData && listRenderType == "createdresult") {
        if (
          !this[`feedlist_${this.TabDataSuffixMap[listRenderType]}`].some(
            (item) => item.feed_id === this.initGenerateFeedData?.feed_id
          )
        ) {
          this[`feedlist_${this.TabDataSuffixMap[listRenderType]}`].unshift(
            this.initGenerateFeedData
          );
          this[`feedlist_${this.TabDataSuffixMap[listRenderType]}`] = [].concat(
            this[`feedlist_${this.TabDataSuffixMap[listRenderType]}`]
          );
        }
        this.initGenerateFeedData = null;
      }
      this[`loadMoreId_${this.TabDataSuffixMap[listRenderType]}`] =
        data?.last_id ?? "";
      // if (listRenderType == "createdresult") {
      // this.updateGenerateFeedDataSse(this.feedlist_createdresult);
      // }
      this.updateGenerateFeedDataSse(
        this[`feedlist_${this.TabDataSuffixMap[listRenderType]}`]
      );
      return this[`feedlist_${this.TabDataSuffixMap[listRenderType]}`];
    },

    updateGenerateFeedDataSse(datas) {
      for (let i = datas.length - 1; i >= 0; i--) {
        if ([1, 2].indexOf(datas[i].state) >= 0) {
          this.doGenerateConnectedSSE.call(
            this,
            datas[i]?.conn_id,
            datas[i]?.feed_id
          );
          datas[i].content = datas[i].content ?? this.generateStepThinkProcessDataMap[datas[i].feed_id]?.markdownTextSource ?? null;
        } else {
          delete this.generateStepThinkProcessDataMap[datas[i].feed_id]
          if (this.curGenerateFeedIdList.includes(datas[i]?.feed_id)) {
            this.curGenerateFeedCount--;
            this.curGenerateFeedIdList.splice(
              this.curGenerateFeedIdList.indexOf(datas[i]?.feed_id),
              1
            );
            this.curGeneratingFeedIdList.splice(
              this.curGeneratingFeedIdList.indexOf(datas[i]?.feed_id),
              1
            );
            delete this.curSseConnectIdMap[datas[i]?.feed_id];
            this.sseGeneratingMap[datas[i]?.feed_id]?.abort();
            delete this.sseGeneratingMap[datas[i]?.feed_id];
          }
        }
      }
    },

    getFeedList(params, done, errordone) {
      const { listRenderType } = params;
      this[`isloading_${this.TabDataSuffixMap[listRenderType]}`] = true;
      this[`params_${listRenderType}`] = params;
      if (!params.title) {
        delete params.title;
      }
      return new Promise(async (resolve, reject) => {
        FeedListStoreApiMap[
          `${listRenderType}_${!!this[`params_${listRenderType}`].title}`
        ](params)
          .then((res) => {
            const { data, code, msg } = res;
            if (code == 200) {
              this[`hasMore_${this.TabDataSuffixMap[listRenderType]}`] = !!data.more;
              let resData = this.initFeedData(data, params);
              resolve(resData);
              done(resData, !data.more);
            } else {
              errordone();
            }
            this[`isloading_${this.TabDataSuffixMap[listRenderType]}`] = false;
          })
          .catch((e) => {
            this[`isloading_${this.TabDataSuffixMap[listRenderType]}`] = false;
            reject(false);
          });
      });
    },

    initialize() {
      this.init(this[`params_${listRenderType}`] ?? {});
    },

    init(params = {}, done, errordone, isSearch, showLoading) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      const { listRenderType } = params;
      let closeMsg = null;
      return new Promise((resolve, reject) => {
        if (showLoading) {
          closeMsg = message.loading({
            position: "center",
            content: $$t("create.loading"),
          });
        }

        this.getFeedList(params, done, errordone, isSearch ?? true)
          .then((datas) => {
            this[`hasInit_${this.TabDataSuffixMap[listRenderType]}`] = true;
            resolve(datas);
            closeMsg && closeMsg.clear();
          })
          .catch((err) => {
            closeMsg && closeMsg.clear();
            reject(err);
          });
      });
    },

    async refresh(params, done, errordone) {
      const { listRenderType } = params;
      return new Promise((resolve, reject) => {
        if (this[`isloading_${this.TabDataSuffixMap[listRenderType]}`]) {
          done && done();
          return;
        }
        this.getFeedList(params, done, errordone)
          .then((datas) => {
            resolve(datas);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    loadMore(done, errordone, listRenderType) {
      return new Promise((resolve, reject) => {
        this[`params_${listRenderType}`].last_id =
          this[`loadMoreId_${this.TabDataSuffixMap[listRenderType]}`];
        if (this[`isloading_${this.TabDataSuffixMap[listRenderType]}`]) {
          done && done();
          reject("loading");
          return;
        }
        if (
          !this[`params_${listRenderType}`].last_id ||
          !this[`hasMore_${this.TabDataSuffixMap[listRenderType]}`]
        ) {
          done && done([], true);
          reject("no more");
          return;
        }
        this[`isloading_${this.TabDataSuffixMap[listRenderType]}`] = true;
        FeedListStoreApiMap[
          `${listRenderType}_${!!this[`params_${listRenderType}`].title}`
        ](this[`params_${listRenderType}`])
          .then((res) => {
            const { data, code, msg } = res;
            if (code == 200) {
              this[`loadMoreId_${this.TabDataSuffixMap[listRenderType]}`] =
                data.last_id;
              this[`feedlist_${this.TabDataSuffixMap[listRenderType]}`] = []
                .concat(this[`feedlist_${this.TabDataSuffixMap[listRenderType]}`])
                .concat(data.list ?? []);
              this.addFeedDataToPlayList(data.list ?? [], listRenderType);
              this.updateGenerateFeedDataSse(data.list);
              done(data.list ?? [], !data.more);
              this[`hasMore_${this.TabDataSuffixMap[listRenderType]}`] = !!data.more;
              resolve(data.list ?? []);
              // if (listRenderType == "createdresult") {
              //   this.updateGenerateFeedDataSse(data.list);
              // }

            } else {
              reject(msg ?? "error qquery code");
              errordone();
            }
            this[`isloading_${this.TabDataSuffixMap[listRenderType]}`] = false;
          })
          .catch((err) => {
            reject(err);
            this[`isloading_${this.TabDataSuffixMap[listRenderType]}`] = false;
            errordone();
          });
      });
    },
    checkCreateRouter(isOpenGenerate, routerName = "create", isCreate, force) {
      const Router = window?.$getVueCurrentInstance?.().appContext?.config?.globalProperties?.$router
      const createLayoutStore = useCreateLayoutStore();
      let editorRouters = ["editor"]
      if (!ModuleOpenStateControl.editor.opened) {
        editorRouters = []
        if (routerName == "editor") {
          routerName = "create"
        }
      }
      if (routerName == "create") {
        createLayoutStore.toggleCreateEditOpenState(isOpenGenerate, true);
      } else if (routerName == "editor") {
        createLayoutStore.toggleEditorOpenState(isOpenGenerate);
      } else if (routerName == "instrumental") {
        createLayoutStore.toggleBgmCreateEditOpenState(isOpenGenerate);
      } else {
      }
      if (createLayoutStore.createRenderType == "mobile" && !force) {
        if (Router?.currentRoute?.value?.name != "library") {
          Router.push({
            name: "library",
          })
        } else {
          this.libraryListRenderTypeScamp = "createdresult__mobile" + new Date().getTime()
        }
        return;
      }
      if (
        isOpenGenerate &&
        Router?.currentRoute?.value?.name != routerName &&
        routerName
      ) {
        Router.push({
          name: routerName,
        });
      } else if (isCreate) {
        if (
          !["create", "createIndex", "bgm", "instrumental", ...editorRouters].includes(
            Router?.currentRoute?.value?.name
          )
        ) {
          Router.push({
            name: routerName,
          });
        }
      } else if (
        ![
          "create",
          "createIndex",
          "library",
          "bgm",
          "instrumental",
          ...editorRouters
        ].includes(Router?.currentRoute?.value?.name)
      ) {
        Router.push({
          name: routerName,
        });
      } else {
      }
    },

    goCredits(
      content,
      { membership_source1, membership_source2, membership_source3 },
      isToSubscribe
    ) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      const userDataStore = useUserDataStore();
      const createLayoutStore = useCreateLayoutStore();
      const is_vip = userDataStore?.userInfo?.user?.is_vip;
      const Router = window?.$getVueCurrentInstance?.().appContext?.config?.globalProperties?.$router
      if (isToSubscribe) {
        if (is_vip) {
          openCreditDialog()
          return;
        }
        Router.push({
          name: "subscribe",
          query: {
            ...(is_vip ? {
              show_credits: 1
            } : {}),
            membership_source1: membership_source1 ?? "create",
            membership_source2,
            ...(membership_source3
              ? {
                membership_source3,
              }
              : {}),
          },
        });
        return;
      }



      // if (this.feedlist_createdresult?.length) {
      //   setTimeout(() => {
      //     createLayoutStore.setFeedSubscribeIsRender(true)
      //   }, 1000)
      // }
      // // window.open(`${window.location.origin}/credits`, "_blank");
      // if (is_vip) {
      //   openCreditDialog()
      //   return;
      // }
      // Router.push({
      //   name: "subscribe",
      //   query: {
      //     ...(is_vip ? {
      //       show_credits: 1
      //     } : {}),
      //     membership_source1: membership_source1 ?? "create",
      //     membership_source2,
      //     ...(membership_source3
      //       ? {
      //         membership_source3,
      //       }
      //       : {}),
      //   },
      // });


      const { show_until, discount_type, discount_percent } = userDataStore?.userInfo?.discount ?? {}
      const isShowConer = show_until == 1 && discount_type > 0 && discount_percent > 0;

      showActionDialog({
        content: content ?? $$t("create.not_enough_credits_action"),
        cancelLabel: $$t("common.cancel"),
        confirmLabel: is_vip ? $$t("create.buy_credits") : $$t("create.subscribe"),
        // is_vip
        //   ? $$t("create.buy_credits")
        //   : $$t("create.open_vip"),
        confirmConer: isShowConer ? `${discount_percent}% ${$$t("credit.off")}` : null,
        type: "subscribe",
        confirm: (closeAction) => {
          closeAction();
          if (this.feedlist_createdresult?.length) {
            createLayoutStore.setFeedSubscribeIsRender(true)
          }

          // window.open(`${window.location.origin}/credits`, "_blank");
          firebaseUtils.logClickEvent("credits_useup", {
            is_vip: is_vip ? 1 : 0,
          });
          if (is_vip) {
            openCreditDialog()
            return;
          }
          Router.push({
            name: "subscribe",
            query: {
              ...(is_vip ? {
                show_credits: 1
              } : {}),
              membership_source1: membership_source1 ?? "create",
              membership_source2,
              ...(membership_source3
                ? {
                  membership_source3,
                }
                : {}),
            },
          });

        },
        cancel: (closeAction) => {
          if (this.feedlist_createdresult?.length) {
            createLayoutStore.setFeedSubscribeIsRender(true)
          }
          if (userDataStore?.isLogin) {
            getInvitePop({}).then((res) => {
              if (res.code == 200) {
                if (res?.data?.pop) {
                  ShowInviteDialog();
                }
              }
            });
          }
          closeAction();
        },
      });
      // message.error({
      //   position: "top",
      //   content: $$t("create.credits_not_enough"),
      // });
    },
    getIsMaxQueueGeneration() {
      return false;
      // const pinia = getActivePinia()
      // const { $$t, $$tValue } = pinia?.$i18n ?? {}
      // doGernerate,doGenerateEasyMode,doEditSongDoneReGenerate,doExtendDoneReGenerate,doRetryGenerate,doRegenerate

      // if (this.curGenerateFeedCount >= 10) {
      //   message.info({
      //     position: "top",
      //     content: $$t("create.max_queue_generation"),
      //   })
      //   return true
      // } else {
      //   return false
      // };
    },

    doGernerate(isInit, sourceData, { optimizedLyricsCallback } = {}) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      const draftDataStore = useDraftDataStore();
      const userDataStore = useUserDataStore();
      const modelDataStore = useModelDataStore();
      return new Promise(async (resolve, reject) => {
        const feedData = draftDataStore.getGenerateDraftData({
          similarData: sourceData?.similarData,
        });
        if (feedData.lyrics?.length < 1) {
          message.info({
            position: "top",
            content: $$t("create.min_letters_lyric"),
          });
          reject($$t("create.min_letters_lyric"));
          return;
        }
        // if (this.generating) {
        //   message.info({
        //     position: "top",
        //     content: $$t("create.has_song_generating"),
        //   });
        //   reject($$t("create.has_song_generating"));
        //   return;
        // }
        if (this.getIsMaxQueueGeneration("doGernerate")) {
          reject("max queue generation");
          return;
        }
        feedData.model = modelDataStore.current_model?.model;
        if (sourceData.need_lyrics_optimize && ModuleOpenStateControl.create.lyricsOptimize) {
          this.generating = true;
          optimizedLyricsCallback().then((lyrics) => {
            feedData.lyrics = lyrics;
            this.doGenerateAdvanceMode(isInit, sourceData, feedData).then((data) => {
              resolve(data);
            }).catch((err) => {
              this.generating = this.getIsGenerating();
              reject(err);
            });
          }).catch((err) => {
            this.generating = this.getIsGenerating();
            reject(err);
          })
        } else {
          this.doGenerateAdvanceMode(isInit, sourceData, feedData).then((data) => {
            resolve(data);
          }).catch((err) => {
            this.generating = this.getIsGenerating();
            reject(err);
          });
        }
      });
    },
    doGenerateAdvanceMode(isInit, sourceData, feedData) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      return new Promise((resolve, reject) => {
        const draftDataStore = useDraftDataStore();
        const userDataStore = useUserDataStore();
        const modelDataStore = useModelDataStore();
        this.curGenerateFeedCount += 1;
        this.generating = true;
        let prompt = feedData.prompt?.content;
        feedListApi
          .doGenerate(feedData)
          .then((res) => {
            const { data, code, msg } = res;
            if (code == 200) {
              draftDataStore.setLastGenerateDraftData(feedData);
              this.last_generate_call_conn_id = data.conn_id;
              draftDataStore.updateFeedId(data.new_id);
              if (isInit) {
                this.initGenerateFeedData = data.feed;
              } else {
                this.initGenerateFeedData = null;
              }
              this.insertGenerateCard(data.feed, false, {
                with_thinking_process: data.with_thinking_process
              });
              this.generating = this.getIsGenerating();

              this.doGenerateConnectedSSE.call(
                this,
                data.conn_id,
                data.feed?.feed_id,
                {
                  model: modelDataStore.current_model,
                  createMode: 'create_advanced'
                }
              );
              userDataStore.refreshUserAccount(true);
              firebaseUtils.logClickEvent("create_generate", {
                tab_stare: "create_advance",
                result: 0,
                mode: "2",
                // type: isInit ? "not_sign_in" : "sign_in",
                musicid: data.feed?.feed_id,
                ...(prompt ? { prompt } : {}),
                control: feedData.museLeadDataType?.join(","),
                lyrics_type: feedData.isAllAiLyrics ? "ai" : "user_edit",
              });
              this.checkCreateRouter(false, "create", true);
              resolve(data);
            } else {
              this.curGenerateFeedCount -= 1;
              this.checkGenerateError(
                {
                  res,
                  isGenerate: true,
                  feedData,
                  mode: "2",
                  membership_source1: "create",
                  membership_source2: "create_advance",
                  tab_stare: "create_advance",
                  ...sourceData,
                },
                prompt ? { prompt } : {}
              );
              this.generating = this.getIsGenerating();
              reject("feed generate failed");
            }
          })
          .catch((err) => {
            this.curGenerateFeedCount -= 1;
            firebaseUtils.logClickEvent("create_generate", {
              tab_stare: "create_advance",
              result: 2,
              mode: "2",
              ...(prompt ? { prompt } : {}),
              control: feedData.museLeadDataType?.join(","),
              lyrics_type: feedData.isAllAiLyrics ? "ai" : "user_edit",
            });
            this.generating = this.getIsGenerating();
            message.error({
              position: "top",
              content: $$t("create.generate_failed"),
            });
            reject(err);
          });
      })
    },
    doGenerateEasyMode(isInit, promptText, souceData) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      const draftDataStore = useDraftDataStore();
      const userDataStore = useUserDataStore();
      const modelDataStore = useModelDataStore();
      const createEasyModeStore = useCreateEasyModeStore();

      return new Promise(async (resolve, reject) => {
        const feedData = promptText
          ? {
            mode: 1,
            prompt: {
              content: promptText,
            },
          }
          : await draftDataStore.getGenerateDraftDataEasyMode();
        // if (this.generating) {
        //   message.info({
        //     position: "top",
        //     content: $$t("create.has_song_generating"),
        //   });
        //   reject($$t("create.has_song_generating"));
        //   return;
        // }

        if (this.getIsMaxQueueGeneration("doGenerateEasyMode")) {
          reject("max queue generation");
          return;
        }

        this.curGenerateFeedCount += 1;
        let prompt = feedData.prompt?.content;

        this.generating = true;
        feedData.model = modelDataStore.current_model?.model;
        const preset =
          Object.values(
            createEasyModeStore.genresPromptmaps_all ?? {}
          ).some((clist) => {
            return clist.some((item) => {
              return item?.content == prompt;
            });
          }) || createEasyModeStore.defaultPromptData?.content == prompt
            ? "1"
            : createEasyModeStore.randomPromptData?.content == prompt
              ? "3"
              : "2";
        feedListApi
          .doGenerate(feedData)
          .then((res) => {
            const { data, code, msg } = res;
            if (code == 200) {
              draftDataStore.setLastGenerateDraftData(feedData);
              this.last_generate_call_conn_id = data.conn_id;
              draftDataStore.updateFeedId(data.new_id);
              // if (isInit) {
              //   this.initGenerateFeedData = data.feed;
              // } else {
              //   this.initGenerateFeedData = null;
              // }
              this.insertGenerateCard(data.feed, false, {
                with_thinking_process: data.with_thinking_process
              });
              this.generating = this.getIsGenerating();
              this.doGenerateConnectedSSE.call(
                this,
                data.conn_id,
                data.feed?.feed_id,
                {
                  model: modelDataStore.current_model,
                  createMode: 'create_basic'
                }
              );
              userDataStore.refreshUserAccount(true);


              // const preset = (createEasyModeStore.data_all?.some((item) => item.prompt?.content == prompt) || createEasyModeStore.defaultPromptData?.content == prompt) ? "1" : "2";
              firebaseUtils.logClickEvent("create_generate", {
                tab_stare: promptText
                  ? "home_basic"
                  : "create_basic",
                prompt,
                preset,
                mode: "1",
                result: 0,
                musicid: data.feed?.feed_id,
                // type: isInit ? "not_sign_in" : "sign_in"
              });

              this.checkCreateRouter(false, "create", true);
              resolve(data);
            } else {
              this.curGenerateFeedCount -= 1;
              this.checkGenerateError(
                {
                  res,
                  isGenerate: true,
                  feedData,
                  mode: "1",
                  membership_source1: "create",
                  membership_source2: promptText
                    ? "home_basic"
                    : "create_basic",

                  tab_stare: "create_basic",
                  ...souceData,
                },
                {
                  prompt,
                }
              );
              this.generating = this.getIsGenerating();
              reject("feed generate failed");
            }
          })
          .catch((err) => {
            this.curGenerateFeedCount -= 1;
            firebaseUtils.logClickEvent("create_generate", {
              prompt,
              preset,
              mode: "1",
              result: 2,
              musicid: data.feed?.feed_id,
              tab_stare: promptText
                ? "home_basic"
                : "create_basic",
            });
            this.generating = this.getIsGenerating();
            message.error({
              position: "top",
              content: $$t("create.generate_failed"),
            });
            reject(err);
          });
      });
    },

    doBgmGernerate(isInit, sourceData) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      const draftDataStore = useDraftDataStore();
      const userDataStore = useUserDataStore();
      const modelDataStore = useModelDataStore();
      return new Promise(async (resolve, reject) => {
        const feedData = draftDataStore.getBgmGenerateAdvanceDraftData();
        let prompt = feedData.prompt?.content;
        // if (this.generating) {
        //   message.info({
        //     position: "top",
        //     content: $$t("create.has_song_generating"),
        //   });
        //   reject($$t("create.has_song_generating"));
        //   return;
        // }
        if (this.getIsMaxQueueGeneration("doGernerate")) {
          reject("max queue generation");
          return;
        }
        this.curGenerateFeedCount += 1;
        this.generating = true;
        feedData.model = modelDataStore.default_model?.model;
        feedListApi
          .doGenerate(feedData)
          .then((res) => {
            const { data, code, msg } = res;
            if (code == 200) {
              draftDataStore.setLastGenerateDraftData(feedData);
              this.last_generate_call_conn_id = data.conn_id;
              draftDataStore.updateFeedId(data.new_id);
              if (isInit) {
                this.initGenerateFeedData = data.feed;
              } else {
                this.initGenerateFeedData = null;
              }
              this.insertGenerateCard(data.feed, false, {
                with_thinking_process: data.with_thinking_process
              });
              this.generating = this.getIsGenerating();

              this.doGenerateConnectedSSE.call(
                this,
                data.conn_id,
                data.feed?.feed_id,
                {
                  model: modelDataStore.default_model,
                  createMode: 'bgm_create_basic'
                }
              );
              userDataStore.refreshUserAccount(true);
              firebaseUtils.logClickEvent("create_generate", {
                tab_stare: "create_bgm_advance",
                result: 0,
                mode: "3",
                musicid: data.feed?.feed_id,
              });
              this.checkCreateRouter(false, "instrumental", true);
              resolve(data);
            } else {
              this.curGenerateFeedCount -= 1;
              this.checkGenerateError(
                {
                  res,
                  isGenerate: true,
                  feedData,
                  mode: "3",
                  membership_source1: "instrumental",
                  membership_source2: "create_advance",
                  tab_stare: "create_bgm_advance",
                  ...sourceData,
                },
                prompt ? { prompt } : {}
              );
              this.generating = this.getIsGenerating();
              reject("feed generate failed");
            }
          })
          .catch((err) => {
            this.curGenerateFeedCount -= 1;
            firebaseUtils.logClickEvent("create_generate", {
              tab_stare: "create_bgm_advance",
              result: 2,
              mode: "3",
            });
            this.generating = this.getIsGenerating();
            message.error({
              position: "top",
              content: $$t("create.generate_failed"),
            });
            reject(err);
          });
      });
    },
    doBgmGenerateEasyMode(isInit, promptText, souceData) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      const draftDataStore = useDraftDataStore();
      const userDataStore = useUserDataStore();
      const modelDataStore = useModelDataStore();
      const bgmCreateEasyModeStore = useBgmCreateEasyModeStore();

      return new Promise(async (resolve, reject) => {
        const feedData = promptText
          ? {
            mode: 4,
            prompt: {
              content: promptText,
            },
          }
          : await draftDataStore.getBgmGenerateDraftDataEasyMode();
        // if (this.generating) {
        //   message.info({
        //     position: "top",
        //     content: $$t("create.has_song_generating"),
        //   });
        //   reject($$t("create.has_song_generating"));
        //   return;
        // }

        if (this.getIsMaxQueueGeneration("doGenerateEasyMode")) {
          reject("max queue generation");
          return;
        }

        this.curGenerateFeedCount += 1;
        let prompt = feedData.prompt?.content;
        feedData.model = modelDataStore.default_model?.model;
        this.generating = true;
        const preset =
          Object.values(
            bgmCreateEasyModeStore.genresPromptmaps_all ?? {}
          ).some((clist) => {
            return clist.some((item) => {
              return item?.content == prompt;
            });
          }) ||
            bgmCreateEasyModeStore.defaultPromptData?.content == prompt
            ? "1"
            : bgmCreateEasyModeStore.randomPromptData?.content == prompt
              ? "3"
              : "2";
        feedListApi
          .doGenerate(feedData)
          .then((res) => {
            const { data, code, msg } = res;
            if (code == 200) {
              draftDataStore.setLastGenerateDraftData(feedData);
              this.last_generate_call_conn_id = data.conn_id;
              draftDataStore.updateFeedId(data.new_id);
              // if (isInit) {
              //   this.initGenerateFeedData = data.feed;
              // } else {
              //   this.initGenerateFeedData = null;
              // }
              this.insertGenerateCard(data.feed, false, {
                with_thinking_process: data.with_thinking_process
              });
              this.generating = this.getIsGenerating();
              this.doGenerateConnectedSSE.call(
                this,
                data.conn_id,
                data.feed?.feed_id,
                {
                  model: modelDataStore.default_model,
                }
              );
              userDataStore.refreshUserAccount(true);


              // const preset = (bgmCreateEasyModeStore.data_all?.some((item) => item.prompt?.content == prompt) || bgmCreateEasyModeStore.defaultPromptData?.content == prompt) ? "1" : "2";
              firebaseUtils.logClickEvent("create_generate", {
                tab_stare: "create_bgm_basic",
                prompt,
                preset,
                mode: "4",
                result: 0,
                musicid: data.feed?.feed_id,
                // type: isInit ? "not_sign_in" : "sign_in"
              });

              this.checkCreateRouter(false, "instrumental", true);
              resolve(data);
            } else {
              this.curGenerateFeedCount -= 1;
              this.checkGenerateError(
                {
                  res,
                  isGenerate: true,
                  feedData,
                  mode: "4",
                  membership_source1: "instrumental",
                  membership_source2: "create_basic",
                  ...souceData,
                  tab_stare: "create_bgm_basic",
                },
                {
                  prompt,
                }
              );
              this.generating = this.getIsGenerating();
              reject("feed generate failed");
            }
          })
          .catch((err) => {
            this.curGenerateFeedCount -= 1;
            firebaseUtils.logClickEvent("create_generate", {
              tab_stare: "create_bgm_basic",
              prompt,
              preset,
              mode: "4",
              result: 2,
              musicid: data.feed?.feed_id,
            });
            this.generating = this.getIsGenerating();
            message.error({
              position: "top",
              content: $$t("create.generate_failed"),
            });
            reject(err);
          });
      });
    },

    doGenerateSimilarAdvanceMode(isInit, params, { optimizedLyricsCallback } = {}) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      const draftDataStore = useDraftDataStore();
      const userDataStore = useUserDataStore();
      const modelDataStore = useModelDataStore();
      return new Promise(async (resolve, reject) => {
        let feedData = await draftDataStore.getGenerateDraftData();

        if (feedData.lyrics?.length < 1) {
          message.info({
            position: "top",
            content: $$t("create.min_letters_lyric"),
          });
          reject($$t("create.min_letters_lyric"));
          return;
        }
        // if (this.generating) {
        //   message.info({
        //     position: "top",
        //     content: $$t("create.has_song_generating"),
        //   });
        //   reject($$t("create.has_song_generating"));
        //   return;
        // }
        if (this.getIsMaxQueueGeneration("doGenerateSimilar")) {
          reject("max queue generation");
          return;
        }

        feedData = { ...feedData, ...params };
        if (params.need_lyrics_optimize && ModuleOpenStateControl.create.lyricsOptimize && optimizedLyricsCallback) {
          this.generating = true;
          optimizedLyricsCallback().then((lyrics) => {
            feedData.lyrics = lyrics;
            this.doGenerateSimilarAdvanceModePost(isInit, params, feedData).then((data) => {
              resolve(data);
            }).catch((err) => {
              this.generating = this.getIsGenerating();
              reject(err);
            });
          }).catch((err) => {
            this.generating = this.getIsGenerating();
            reject(err);
          })
        } else {
          this.doGenerateSimilarAdvanceModePost(isInit, params, feedData).then((data) => {
            resolve(data);
          }).catch((err) => {
            this.generating = this.getIsGenerating();
            reject(err);
          });
        }
      });
    },
    doGenerateSimilarAdvanceModePost(isInit, params, feedData) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      return new Promise((resolve, reject) => {
        const draftDataStore = useDraftDataStore();
        const userDataStore = useUserDataStore();
        const modelDataStore = useModelDataStore();
        this.curGenerateFeedCount += 1;
        this.generating = true;
        let prompt = feedData.prompt?.content;
        feedListApi
          .generateSimilarSong(feedData)
          .then((res) => {
            const { data, code, msg } = res;
            if (code == 200) {
              draftDataStore.setLastGenerateDraftData(feedData);
              this.last_generate_call_conn_id = data.conn_id;
              draftDataStore.updateFeedId(data.new_id);
              if (isInit) {
                this.initGenerateFeedData = data.feed;
              } else {
                this.initGenerateFeedData = null;
              }
              this.insertGenerateCard(data.feed, false, {
                with_thinking_process: data.with_thinking_process
              });
              this.generating = this.getIsGenerating();

              this.doGenerateConnectedSSE.call(
                this,
                data.conn_id,
                data.feed?.feed_id,
                {
                  model: modelDataStore.current_model,
                }
              );
              userDataStore.refreshUserAccount(true);

              firebaseUtils.logClickEvent("create_generate", {
                tab_stare: "create_advance_similar",
                result: 0,
                mode: "2",
                // type: isInit ? "not_sign_in" : "sign_in",
                musicid: data.feed?.feed_id,
                ...(prompt ? { prompt } : {}),
                control: feedData.museLeadDataType?.join(","),
                lyrics_type: feedData.isAllAiLyrics ? "ai" : "user_edit",
                is_similar: "true",
              });
              this.checkCreateRouter(false, "create", true);
              resolve(data);
            } else {
              this.curGenerateFeedCount -= 1;
              this.checkGenerateError(
                {
                  res,
                  isGenerate: true,
                  feedData,
                  mode: "2",
                  membership_source1: "create",
                  membership_source2: "create_advance_similar",
                  similar: "true",
                  tab_stare: "create_advance_similar",
                },
                prompt ? { prompt } : {}
              );
              this.generating = this.getIsGenerating();
              reject("feed generate failed");
            }
          })
          .catch((err) => {
            this.curGenerateFeedCount -= 1;
            firebaseUtils.logClickEvent("create_generate", {
              tab_stare: "create_advance_similar",
              result: 2,
              mode: "2",
              ...(prompt ? { prompt } : {}),
              control: feedData.museLeadDataType?.join(","),
              lyrics_type: feedData.isAllAiLyrics ? "ai" : "user_edit",
              similar: "true",
            });
            this.generating = this.getIsGenerating();
            message.error({
              position: "top",
              content: $$t("create.generate_failed"),
            });
            reject(err);
          });
      });
    },
    doGenerateSimilarEasyMode(data, promptData, isInit) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      const draftDataStore = useDraftDataStore();
      const userDataStore = useUserDataStore();
      const modelDataStore = useModelDataStore();
      return new Promise(async (resolve, reject) => {
        const feedData = {
          ...data,
          prompt: promptData,
          mode: 1,
        };
        let prompt = feedData.prompt?.content;
        if (feedData.lyrics?.length < 1) {
          message.info({
            position: "top",
            content: $$t("create.min_letters_lyric"),
          });
          reject($$t("create.min_letters_lyric"));
          return;
        }
        // if (this.generating) {
        //   message.info({
        //     position: "top",
        //     content: $$t("create.has_song_generating"),
        //   });
        //   reject($$t("create.has_song_generating"));
        //   return;
        // }
        if (this.getIsMaxQueueGeneration("doGenerateSimilarEasyMode")) {
          reject("max queue generation");
          return;
        }
        this.curGenerateFeedCount += 1;
        this.generating = true;
        feedListApi
          .generateSimilarSong(feedData)
          .then((res) => {
            const { data, code, msg } = res;
            if (code == 200) {
              draftDataStore.setLastGenerateDraftData(feedData);
              this.last_generate_call_conn_id = data.conn_id;
              draftDataStore.updateFeedId(data.new_id);
              if (isInit) {
                this.initGenerateFeedData = data.feed;
              } else {
                this.initGenerateFeedData = null;
              }
              this.insertGenerateCard(data.feed, false, {
                with_thinking_process: data.with_thinking_process
              });
              this.generating = this.getIsGenerating();

              this.doGenerateConnectedSSE.call(
                this,
                data.conn_id,
                data.feed?.feed_id,
                {
                  model: modelDataStore.default_model,
                }
              );
              userDataStore.refreshUserAccount(true);

              firebaseUtils.logClickEvent("create_generate", {
                tab_stare: "create_basic_similar",
                result: 0,
                mode: "2",
                // type: isInit ? "not_sign_in" : "sign_in",
                musicid: data.feed?.feed_id,
                ...(prompt ? { prompt } : {}),
                // control: feedData.museLeadDataType?.join(","),
                lyrics_type: feedData.isAllAiLyrics ? "ai" : "user_edit",
                is_similar: "true",
              });
              this.checkCreateRouter(false, "create", true);
              resolve(data);
            } else {
              this.curGenerateFeedCount -= 1;
              this.checkGenerateError(
                {
                  res,
                  isGenerate: true,
                  feedData,
                  mode: "2",
                  membership_source1: "create",
                  membership_source2: "create_basic_similar",
                  similar: "true",
                  tab_stare: "create_basic_similar",
                },
                prompt ? { prompt } : {}
              );
              this.generating = this.getIsGenerating();
              reject("feed generate failed");
            }
          })
          .catch((err) => {
            this.curGenerateFeedCount -= 1;
            firebaseUtils.logClickEvent("create_generate", {
              tab_stare: "create_basic_similar",
              result: 0,
              mode: "2",
              // type: isInit ? "not_sign_in" : "sign_in",
              ...(prompt ? { prompt } : {}),
              // control: feedData.museLeadDataType?.join(","),
              lyrics_type: feedData.isAllAiLyrics ? "ai" : "user_edit",
              is_similar: "true",
            });
            this.generating = this.getIsGenerating();
            message.error({
              position: "top",
              content: $$t("create.generate_failed"),
            });
            reject(err);
          });
      });
    },
    doGenerateBgmSimilarAdvanceMode(isInit) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      const draftDataStore = useDraftDataStore();
      const userDataStore = useUserDataStore();
      return new Promise(async (resolve, reject) => {
        const feedData = await draftDataStore.getBgmGenerateDraftData();
        let prompt = feedData.prompt?.content;
        if (feedData.lyrics?.length < 1) {
          message.info({
            position: "top",
            content: $$t("create.min_letters_lyric"),
          });
          reject($$t("create.min_letters_lyric"));
          return;
        }
        // if (this.generating) {
        //   message.info({
        //     position: "top",
        //     content: $$t("create.has_song_generating"),
        //   });
        //   reject($$t("create.has_song_generating"));
        //   return;
        // }
        if (this.getIsMaxQueueGeneration("doGenerateBgmSimilarAdvanceMode")) {
          reject("max queue generation");
          return;
        }
        this.curGenerateFeedCount += 1;
        this.generating = true;
        feedData.mode = 3;
        feedListApi
          .doGenerate(feedData)
          .then((res) => {
            const { data, code, msg } = res;
            if (code == 200) {
              draftDataStore.setLastGenerateDraftData(feedData);
              this.last_generate_call_conn_id = data.conn_id;
              draftDataStore.updateFeedId(data.new_id);
              if (isInit) {
                this.initGenerateFeedData = data.feed;
              } else {
                this.initGenerateFeedData = null;
              }
              this.insertGenerateCard(data.feed, false, {
                with_thinking_process: data.with_thinking_process
              });
              this.generating = this.getIsGenerating();

              this.doGenerateConnectedSSE.call(
                this,
                data.conn_id,
                data.feed?.feed_id
              );
              userDataStore.refreshUserAccount(true);

              firebaseUtils.logClickEvent("create_generate", {
                tab_stare: "create_bgm_advance_similar",
                result: 0,
                mode: "3",
                // type: isInit ? "not_sign_in" : "sign_in",
                musicid: data.feed?.feed_id,
                ...(prompt ? { prompt } : {}),
                control: feedData.museLeadDataType?.join(","),
                lyrics_type: feedData.isAllAiLyrics ? "ai" : "user_edit",
                is_similar: "true",
              });
              this.checkCreateRouter(false, "instrumental", true);
              resolve(data);
            } else {
              this.curGenerateFeedCount -= 1;
              this.checkGenerateError(
                {
                  res,
                  isGenerate: true,
                  feedData,
                  mode: "3",
                  membership_source1: "instrumental",
                  membership_source2: "create_advance_similar",
                  similar: "true",
                  tab_stare: "create_bgm_advance_similar",
                },
                prompt ? { prompt } : {}
              );
              this.generating = this.getIsGenerating();
              reject("feed generate failed");
            }
          })
          .catch((err) => {
            this.curGenerateFeedCount -= 1;
            firebaseUtils.logClickEvent("create_generate", {
              tab_stare: "create_bgm_advance_similar",
              result: 2,
              mode: "3",
              // type: isInit ? "not_sign_in" : "sign_in",
              ...(prompt ? { prompt } : {}),
              control: feedData.museLeadDataType?.join(","),
              lyrics_type: feedData.isAllAiLyrics ? "ai" : "user_edit",
              is_similar: "true",
            });
            this.generating = this.getIsGenerating();
            message.error({
              position: "top",
              content: $$t("create.generate_failed"),
            });
            reject(err);
          });
      });
    },
    doGenerateBgmSimilarEasyMode(data, promptData, isInit) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      const draftDataStore = useDraftDataStore();
      const userDataStore = useUserDataStore();
      const modelDataStore = useModelDataStore();
      return new Promise(async (resolve, reject) => {
        const feedData = {
          ...data,
          prompt: promptData,
          mode: 4,
        };
        let prompt = feedData.prompt?.content;
        if (feedData.lyrics?.length < 1) {
          message.info({
            position: "top",
            content: $$t("create.min_letters_lyric"),
          });
          reject($$t("create.min_letters_lyric"));
          return;
        }
        // if (this.generating) {
        //   message.info({
        //     position: "top",
        //     content: $$t("create.has_song_generating"),
        //   });
        //   reject($$t("create.has_song_generating"));
        //   return;
        // }
        if (this.getIsMaxQueueGeneration("doGenerateBgmSimilarEasyMode")) {
          reject("max queue generation");
          return;
        }
        this.curGenerateFeedCount += 1;
        this.generating = true;
        feedListApi
          .generateSimilarSong(feedData)
          .then((res) => {
            const { data, code, msg } = res;
            if (code == 200) {
              draftDataStore.setLastGenerateDraftData(feedData);
              this.last_generate_call_conn_id = data.conn_id;
              draftDataStore.updateFeedId(data.new_id);
              if (isInit) {
                this.initGenerateFeedData = data.feed;
              } else {
                this.initGenerateFeedData = null;
              }
              this.insertGenerateCard(data.feed, false, {
                with_thinking_process: data.with_thinking_process
              });
              this.generating = this.getIsGenerating();

              this.doGenerateConnectedSSE.call(
                this,
                data.conn_id,
                data.feed?.feed_id,
                {
                  model: modelDataStore.default_model,
                }
              );
              userDataStore.refreshUserAccount(true);

              firebaseUtils.logClickEvent("create_generate", {
                tab_stare: "create_bgm_basic_similar",
                result: 0,
                mode: "4",
                musicid: data.feed?.feed_id,
                ...(prompt ? { prompt } : {}),
                is_similar: "true",
              });
              this.checkCreateRouter(false, "instrumental", true);
              resolve(data);
            } else {
              this.curGenerateFeedCount -= 1;
              this.checkGenerateError(
                {
                  res,
                  isGenerate: true,
                  feedData,
                  mode: "4",
                  membership_source1: "instrumental",
                  membership_source2: "create_basic_similar",
                  similar: "true",
                  tab_stare: "create_bgm_basic_similar",
                },
                prompt ? { prompt } : {}
              );
              this.generating = this.getIsGenerating();
              reject("feed generate failed");
            }
          })
          .catch((err) => {
            this.curGenerateFeedCount -= 1;
            firebaseUtils.logClickEvent("create_generate", {
              tab_stare: "create_bgm_basic_similar",
              result: 2,
              mode: "4",
              ...(prompt ? { prompt } : {}),
              is_similar: "true",
            });
            this.generating = this.getIsGenerating();
            message.error({
              position: "top",
              content: $$t("create.generate_failed"),
            });
            reject(err);
          });
      });
    },
    checkGenerateError(
      {
        type,
        res,
        isGenerate,
        feedData,
        mode,
        membership_source1,
        membership_source2,
        similar,
        tab_stare,
      },
      logParams
    ) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      const museDataStore = useMuseDataStore();
      const userDataStore = useUserDataStore();
      const is_vip = userDataStore?.userInfo?.user?.is_vip;
      let machine_audit_state = null;
      const Router = window?.$getVueCurrentInstance?.().appContext?.config?.globalProperties?.$router
      switch (res.code) {
        case 6101:
          message.info({
            position: "top",
            content: $$t("create.has_song_generating"),
          });
          break;

        case 6103: // 标题不合规
          message.error({
            position: "top",
            content: $$t("create.generate_title_audit_failed"),
          });
          break;
        case 6316:
          message.error({
            position: "top",
            content: $$t("create.generate_title_audit_failed"),
          });
          break;

        case 6104:
          message.error({
            position: "top",
            content: $$t("create.generate_lyric_audit_failed"),
          });
          break;
        case 6356:
          message.error({
            position: "top",
            content: $$t("create.generate_lyric_audit_failed"),
          });
          break;
        case 6357:
          message.error({
            position: "top",
            content: $$t("create.generate_lyric_audit_failed"),
          })
          break

        case 6108: // 没用
          message.error({
            position: "top",
            content: $$t("create.generate_prompt_audit_failed"),
          });
          break;
        case 6314:
          machine_audit_state = 2;
          message.info({
            position: "top",
            content: $$t("create.song_state_auditing"),
          });
          break;

        case 6315:
          machine_audit_state = 4;
          if (["trim_editing", "lyrics_translate", "cover_voice", "extend_editing", "region_editing"].includes(type)) {
            message.info({
              position: "top",
              content: $$t("create.song_state_auditing_failed"),
            })
          } else {
            message.info({
              position: "top",
              content: $$t("create.song_state_auditing_failed_disabled"),
            });
          }
          // this.updateFeedSongItem({
          //   song_id: item.song_id,
          //   machine_audit_state,
          // });
          break;

        case 6317: // 没用
          message.error({
            position: "top",
            content: $$t("create.generate_refer_audit_failed"),
          });
          if (isGenerate) {
            museDataStore.deleteMuseDataByAudit(feedData);
          }
          break;

        case 6310:
          // 积分不足
          // message.error({
          //   position: "top",
          //   content: $$t("create.credits_not_enough"),
          // });
          if (["extend_editing", "region_editing"].includes(type)) {
            openCreditDialog();
          } else {
            this.goCredits(null, { membership_source2, membership_source1 });
          }
          firebaseUtils.logClickEvent("create_generate", {
            result: 1,
            mode,
            tab_stare,
            is_similar: similar,
            ...(logParams ?? {}),
          });
          break;

        case 6301:
        case 6302:
        case 6308:
          message.error({
            position: "top",
            content: $$t("create.generate_failed"),
          });
          firebaseUtils.logClickEvent("create_generate", {
            result: 2,
            mode: mode,
            is_similar: similar,
            tab_stare,
            ...(logParams ?? {}),
          });
          break;

        case 6303: // 不是会员
          // message.info({
          //   position: "top",
          //   content: $$t("create.has_song_generating"),
          // });
          // this.goCredits(null, { membership_source2, membership_source1, membership_source3: 'multi_run' });
          Router.push({
            name: "subscribe",
            query: {
              ...(is_vip ? {
                show_credits: 1
              } : {}),
              membership_source1: membership_source1 ?? "create",
              membership_source2,
              membership_source3: "multi_run",
            },
          });
          break;

        case 6323:
          message.error({
            position: "top",
            content: $$t("create.generate_task_upper_limit"),
          });
          break;

        case 6335:
          message.error({
            position: "top",
            content: $$t("editor.subscripe_level_not_met"),
          });
          Router.push({
            name: "subscribe",
            query: {
              membership_source1: membership_source1 ?? "create",
              membership_source2,
            },
          });
          break;



        case 6351: // vocal
          message.error({
            position: "top",
            content: $$t("create.generate_vocal_audit_failed"),
          });
          break;
        case 6352: // refer
          message.error({
            position: "top",
            content: $$t("create.generate_refer_audit_failed"),
          });
          break;
        case 6353: // motif
          message.error({
            position: "top",
            content: $$t("create.generate_motif_audit_failed"),
          });
          break;
        case 6354: // prompt
          message.error({
            position: "top",
            content: $$t("create.generate_prompt_audit_failed"),
          });
          break;

        case 6340:
          message.error({
            position: "top",
            content: $$t("create.not_generate_because_not_support_language"),
          });
          break;

        case 9008:
          message.error({
            position: "top",
            content: $$t("common.tooFrequently"),
          });
          break;
        case 10011:
          message.error({
            position: "top",
            content: $$t("create.extend_too_long_generate_failed"),
          });
          break;
        case 10010:
          message.error({
            position: "top",
            content: $$t("create.generate_failed_melody_feed"),
          });
          break;

        default:
          message.error({
            position: "top",
            content: $$t("create.generate_failed"),
          });
          firebaseUtils.logClickEvent("create_generate", {
            result: 2,
            mode: mode,
            tab_stare,
            is_similar: similar,
            ...(logParams ?? {}),
          });
          break;
      }
    },
    insertGenerateCard(data, isResult, extendData) {
      const globalPlayDataStore = useGlobalPlayDataStore();
      const createLayoutStore = useCreateLayoutStore();
      if ([1, 2].includes(data.state) && extendData?.with_thinking_process) {
        data.content = data.content ?? '';
        data.with_thinking_process = true
      }
      if (
        !this.feedlist_createdresult.some(
          (item) => item.feed_id == data.feed_id
        )
      ) {
        // if (!data?.is_accelerated) {
        //   createLayoutStore.setFeedSubscribeIsRender(true);
        // }
        this.feedlist_createdresult.unshift(data);
        this.feedlist_createdresult = [].concat(this.feedlist_createdresult);
      }
      if (isResult) {
        if (
          !this.feedlist_mysong.some((item) => item.feed_id == data.feed_id)
        ) {
          // if (!data?.is_accelerated) {
          //   createLayoutStore.setFeedSubscribeIsRender(true);
          // }
          this.feedlist_mysong.unshift(data);
          this.feedlist_mysong = [].concat(this.feedlist_mysong);
        }
      }
      nextTick().then(() => {
        globalPlayDataStore.updatePlayDataItem();
      });
    },
    updateGenerateThinkingCard(item) {
      if (
        this['feedlist_createdresult'].some((feedItem) => {
          if (feedItem.feed_id == item.feed_id) {
            if (feedItem.content && item.content.startsWith(feedItem.content)) {
              feedItem.content = item.content;
            } else {
              feedItem.content = (feedItem.content ?? '') + item.content;
            }
            feedItem.done = item.done;
            return true;
          }
        })) {
        this['feedlist_createdresult'] = [].concat(this['feedlist_createdresult']);
      }
    },
    updateGenerateCard(item) {
      const storeDetailDataStore = useStoreDetailData();
      const globalPlayDataStore = useGlobalPlayDataStore();
      item.feed_id = item.feed_id ?? feedid;
      if (item?.state >= 3) {
        delete this.generateStepThinkProcessDataMap[item.feed_id]
      }
      // 更新播放和详细数据
      const updateStoreWithSong = (songList, state, song_id, storeCallback) => {
        let songNew = null;
        const targetSong = songList.find((song) => {
          if (song.song_id == song_id) {
            songNew = song;
            return true;
          } else {
            return false;
          }
        });
        if (targetSong)
          storeCallback({
            ...songNew,
            feed_id: item.feed_id,
            pstate: state,
          });
      };

      if (item.songs) {
        updateStoreWithSong(
          item.songs,
          item.state,
          storeDetailDataStore.info?.song_id,
          storeDetailDataStore.updateSongDetail
        );
        item.songs.forEach((song) => {
          globalPlayDataStore.updatePlayDataItem({
            ...song,
            feed_id: item.feed_id,
            pstate: item.state,
          });
        });
      }
      // 更新指定列表
      const updateFeedList = (listKey) => {
        const list = this[listKey];
        if (!Array.isArray(list)) return false;

        return list.some((feedItem) => {
          if (feedItem.feed_id === item.feed_id) {
            if (listKey == "feedlist_createdresult" || listKey == "mysong") {
              if (item.songs?.length) {
                if (feedItem.songs?.length) {
                  if (
                    feedItem.songs?.length == item.songs?.length &&
                    feedItem.songs?.every((song) =>
                      item.songs?.some((fsong) => fsong.song_id == song.song_id)
                    )
                  ) {
                    [...feedItem.songs, ...item.songs].forEach((song) => {
                      if (song?.recall) {
                        globalPlayDataStore.removeSongItemAndSwitchNext(song);
                      }
                    });
                  } else {
                    if (item.songs?.length < feedItem.songs?.length) {
                      feedItem.songs?.forEach((song) => {
                        if (
                          !item.songs?.some(
                            (fsong) => fsong.song_id == song.song_id
                          )
                        ) {
                          globalPlayDataStore.removeSongItemAndSwitchNext(song);
                        }
                      });
                    }
                  }
                } else {
                  item.songs?.forEach((song) => {
                    if (song?.recall) {
                      globalPlayDataStore.removeSongItemAndSwitchNext(song);
                    }
                  });
                }
              } else if (feedItem?.songs?.length) {
                feedItem.songs?.forEach((song) => {
                  globalPlayDataStore.removeSongItemAndSwitchNext(song);
                });
              } else {
              }
              Object.assign(feedItem, item);
            } else {
              Object.assign(feedItem, item, {
                songs: feedItem.songs?.map((song) => {
                  const matchingSong = item.songs.find(
                    (fsong) => fsong.song_id === song.song_id
                  );
                  return matchingSong
                    ? Object.assign(song, matchingSong, {
                      stream_key:
                        matchingSong.stream_key ?? song.stream_key ?? null,
                    })
                    : song;
                }),
              });
            }
            return true;
          }
          return false;
        });
      };

      this.TabDataSuffixLists.forEach((suffix) => {
        const listKey = `feedlist_${suffix}`;
        if (updateFeedList(listKey)) {
          this[listKey] = [].concat(this[listKey]);
        }
      });

      if (
        globalPlayDataStore.curPlayData &&
        storeDetailDataStore.info?.feed_id == item.feed_id &&
        globalPlayDataStore.curPlayData?.song_id ==
        storeDetailDataStore.info?.feed_id
      ) {
        [...item.songs].forEach((song) => {
          if (song?.recall) {
            globalPlayDataStore.removeSongItemAndSwitchNext(song);
          }
        });
      } else {
        if (
          globalPlayDataStore.curPlayData &&
          !item?.songs?.length &&
          storeDetailDataStore.info?.feed_id == item.feed_id &&
          globalPlayDataStore.curPlayData?.song_id ==
          storeDetailDataStore.info?.feed_id
        ) {
          globalPlayDataStore.removeSongItemAndSwitchNext(
            globalPlayDataStore.curPlayData
          );
        }
      }
    },

    updateFeedSongItem(data, isRerender = true) {
      const storeDetailDataStore = useStoreDetailData();
      const globalPlayDataStore = useGlobalPlayDataStore();
      const { song_id, ...obj } = data;
      const updateSongInList = (list) => {
        return list.some((itemF) =>
          itemF.songs?.some((song) => {
            if (song.song_id == song_id) {
              Object.assign(song, obj);
              return true;
            }
            return false;
          })
        );
      };
      this.TabDataSuffixLists.forEach((suffix) => {
        const listKey = `feedlist_${suffix}`;
        if (this[listKey] && updateSongInList(this[listKey])) {
          if (isRerender) {
            this[listKey] = [].concat(this[listKey]); // 触发响应式更新
          }
        }
      });

      storeDetailDataStore.updateSongDetail(data);
      globalPlayDataStore.updatePlayDataItem(data);
    },
    getIsGenerating() {
      return this.curGenerateFeedIdList?.length;
    },
    doGenerateConnectedSSE(
      conn_id,
      feed_id,
      { isQueueCall = false, model = null, createMode = null } = {}
    ) {
      const pinia = getActivePinia()
      const { $$t, $$tValue } = pinia?.$i18n ?? {}
      // if (this.generating) {
      //   return;
      // }
      if (!conn_id) {
        return;
      }
      const storeDetailDataStore = useStoreDetailData();
      const globalPlayDataStore = useGlobalPlayDataStore();
      const userDataStore = useUserDataStore();
      const createLayoutStore = useCreateLayoutStore();
      const globalUserStateStore = useGlobalUserStateStore();
      const modelDataStore = useModelDataStore()
      const Router = window?.$getVueCurrentInstance?.().appContext?.config?.globalProperties?.$router
      if (
        (!this.curGenerateFeedIdList.includes(feed_id) || isQueueCall) &&
        !this.sseGeneratingMap[feed_id]
      ) {
        console.log(
          "this.curGenerateFeedIdList",
          this.sseGeneratingMap,
          feed_id
        );
        if (!isQueueCall) {
          this.curSseConnectIdMap[feed_id] = conn_id;
          this.curGenerateFeedIdList.push(feed_id);
        }
        // 避免并发6个限制，同一时刻最多保持两个sse连接，如果 需要多个则排队
        if (
          this.curGeneratingFeedIdList.length <= 1 &&
          !this.sseGeneratingMap[feed_id] &&
          this.curGenerateFeedIdList.includes(feed_id)
        ) {
          this.generating = true;
          this.curGeneratingFeedIdList.push(feed_id);
          try {
            this.sseGeneratingMap[feed_id] = {
              abort: () => { },
            };
            this.sseGeneratingConnIdMap[conn_id] = true;
            sseGenerateApi
              .doSseGetGenerate({
                params: `conn_id=${conn_id}`,
                onOpen: (e) => {
                  this.sseGeneratingConnIdMap[conn_id] = true;
                },
                onMessage: (res) => {
                  try {
                    if (["inf_feed", "pgc_feed", "pgc_feed_thinking"].indexOf(res.event) >= 0) {
                      const feeddata = JSON.parse(res.data ?? "{}");
                      if (res.event == "pgc_feed_thinking") {
                        this.updateGenerateThinkingCard(feeddata);
                        return;
                      }
                      let showMessage = [
                        "createIndex",
                        "library",
                        "create",
                        "editor",
                        "bgm",
                      ].includes(Router.currentRoute.value?.name);
                      const isDetailPage = [
                        "songDetail",
                        "songDetailOld",
                      ].includes(Router.currentRoute.value?.name);
                      let isCurPlayData = false;
                      let songs = feeddata?.songs;

                      if (
                        songs?.every((item) => {
                          if (
                            item?.song_id ==
                            globalPlayDataStore.curPlayData?.song_id
                          ) {
                            isCurPlayData = true;
                          }
                          if (item.recall) {
                            globalPlayDataStore.removeSongItemAndSwitchNext(
                              item,
                              true
                            );
                          }
                        })
                      ) {
                        showMessage = isDetailPage
                          ? isCurPlayData
                          : showMessage;
                      } else if (
                        storeDetailDataStore.info &&
                        !songs?.length &&
                        [4, 6, 10, 11].includes(feeddata?.state) &&
                        storeDetailDataStore.info?.feed_id == feeddata.feed_id
                      ) {
                        globalPlayDataStore.removeSongItemAndSwitchNext(
                          storeDetailDataStore.info,
                          true
                        );
                      } else {
                      }

                      if ([3, 12].includes(feeddata?.state)) {
                        if (feeddata.code == 10001) {
                          if (showMessage) {
                            message.error({
                              position: "top",
                              content: $$tValue(
                                "create.new_user_generated_success_only_one",
                                {
                                  count: 1,
                                }
                              ),
                            });
                          }
                          userDataStore.refreshUserAccount(true);
                        } else if (feeddata.code == 10000) {
                          let count = 0;
                          feeddata.songs?.forEach((item, index) => {
                            if (item.recall) {
                              count++;
                            }
                          });
                          if (count > 0) {
                            if (showMessage) {
                              message.error({
                                position: "top",
                                content: $$tValue(
                                  "create.generating_some_error",
                                  {
                                    count: model?.need_credit_alert
                                      ? (model.required_credits / 2) * count
                                      : ((model?.required_credits ?? 2) / 2) *
                                      count,
                                  }
                                ),
                              });
                            }
                            userDataStore.refreshUserAccount(true);
                          }
                        } else if (
                          feeddata.songs.some(
                            (item) => item.machine_audit_state == 4
                          )
                        ) {
                          message.info({
                            position: "top",
                            content: $$t("create.song_state_auditing_failed_disabled"),
                          });
                        } else {
                        }
                      }

                      this.updateGenerateCard(feeddata, feed_id);

                      if (feeddata?.state == 4 || feeddata?.state == 6) {
                        userDataStore.refreshUserAccount(true);
                      }
                    } else if (['error'].includes(res.event)) {
                    } else {
                      if (res.event == "done") {
                        this.curGenerateFeedIdList.splice(
                          this.curGenerateFeedIdList.indexOf(feed_id),
                          1
                        );
                        this.generating = this.getIsGenerating();
                        let noGeneratingFeedIdList =
                          this.curGenerateFeedIdList.filter(
                            (item) =>
                              !this.curGeneratingFeedIdList.includes(item)
                          );
                        this.curGeneratingFeedIdList.splice(
                          this.curGeneratingFeedIdList.indexOf(feed_id),
                          1
                        );
                        if (noGeneratingFeedIdList.length) {
                          this.doGenerateConnectedSSE.call(
                            this,
                            this.curSseConnectIdMap[noGeneratingFeedIdList[0]],
                            noGeneratingFeedIdList[0],
                            {
                              isQueueCall: true,
                              model: model,
                            }
                          );
                        }
                        this.curGenerateFeedCount -= 1;
                        this.sseGeneratingMap[feed_id]?.abort();
                        delete this.sseGeneratingMap[feed_id];
                        // if (createMode == 'create_advanced' && createLayoutStore.createEditMode != "easy") {
                        //   globalUserStateStore.showBasicModeClickedGuidVisible("easy")
                        // } else if (createMode == 'create_basic' && createLayoutStore.createEditMode != "hard") {
                        //   globalUserStateStore.showBasicModeClickedGuidVisible("hard")
                        // } else { }
                      }
                    }
                  } catch (e) {
                    console.error("doGenerateConnectedSSE__onCatchError", e);
                  }
                },
                onError: (e) => {
                  console.error("doGenerateConnectedSSE__onError", e);
                  this.sseGeneratingConnIdMap[conn_id] = false;
                },
                onClose: (e) => {
                  this.sseGeneratingConnIdMap[conn_id] = false;
                  delete this.sseGeneratingMap[feed_id];
                  this.curGenerateFeedIdList.splice(
                    this.curGenerateFeedIdList.indexOf(feed_id),
                    1
                  );
                  this.curGeneratingFeedIdList.splice(
                    this.curGeneratingFeedIdList.indexOf(feed_id),
                    1
                  );
                  this.generating = this.getIsGenerating();
                },
              })
              .then((sseRes) => {
                this.sseGeneratingMap[feed_id] = sseRes;
              })
              .catch((e) => {
                this.curGeneratingFeedIdList.splice(
                  this.curGeneratingFeedIdList.indexOf(feed_id),
                  1
                );
                this.sseGeneratingConnIdMap[conn_id] = null;
                delete this.sseGeneratingMap[feed_id];
              });
          } catch (e) {
            console.error("doGenerateConnectedSSE__catch", e);
            this.curGeneratingFeedIdList.splice(
              this.curGeneratingFeedIdList.indexOf(feed_id),
              1
            );
            this.sseGeneratingConnIdMap[conn_id] = null;
            delete this.sseGeneratingMap[feed_id];
          }
        }
      }
    },


    doRestore(pitem, item) {
      const draftDataStore = useDraftDataStore();
      const createLayoutStore = useCreateLayoutStore();
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      return new Promise((resolve, reject) => {
        showActionDialog({
          content: $$t("create.restore_alert"),
          cancelLabel: $$t("create.cancel"),
          confirmLabel: $$t("create.confirm"),
          confirm: (closeAction) => {
            closeAction();
            const closeLoading = message.loading({
              position: "center",
              content: $$t("create.restoring"),
            });
            feedListApi
              .reEditCurFeedDraft({
                feed_id: pitem.feed_id,
                song_id: item.song_id,
              })
              .then((res) => {
                closeLoading?.clear();
                if (res.code == 200) {
                  draftDataStore.setDraftData(res.data, true);
                  resolve();
                  this.checkCreateRouter(
                    true,
                    [3, 4].includes(res.data?.mode) ? "instrumental" : "create",
                    true,
                    true
                  );
                } else {
                  let machine_audit_state = null;
                  if (res.code == 6314) {
                    machine_audit_state = 2;
                    message.info({
                      position: "top",
                      content: $$t("create.song_state_auditing"),
                    });
                    reject($$t("create.song_state_auditing"));
                  } else if (res.code == 6315) {
                    machine_audit_state = 4;
                    message.info({
                      position: "top",
                      content: $$t("create.song_state_auditing_failed_disabled"),
                    });
                    reject($$t("create.song_state_auditing_failed_disabled"));
                    this.updateFeedSongItem({
                      song_id: item.song_id,
                      machine_audit_state,
                    });
                  } else {
                    message.error({
                      position: "top",
                      content: $$t("create.restore_failed"),
                    });
                    reject($$t("create.restore_failed"));
                  }
                }
              })
              .catch((err) => {
                closeLoading?.clear();
                console.error(err);
                message.error({
                  position: "top",
                  content: $$t("create.restore_failed"),
                });
                reject($$t("create.restore_failed"));
              });
          },
          cancel(closeAction) {
            closeAction();
            reject("User canceled");
          },
        });
      });
    },

    doRegenerate(pitem, item) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      const userDataStore = useUserDataStore();
      return new Promise((resolve, reject) => {
        // if (this.generating) {
        //   message.info({
        //     position: "top",
        //     content: $$t("create.has_song_generating"),
        //   });
        //   reject($$t("create.has_song_generating"));
        //   return;
        // }
        if (this.getIsMaxQueueGeneration("doRegenerate")) {
          reject("max queue generation");
          return;
        }

        this.curGenerateFeedCount += 1;
        feedListApi
          .feedCardGenerate({})
          .then((res) => {
            const { data, code, msg } = res;
            if (code == 200) {
              this.last_generate_call_conn_id = data.conn_id;
              this.insertGenerateCard(data.feed, false, {
                with_thinking_process: data.with_thinking_process
              });
              this.generating = this.getIsGenerating();
              this.doGenerateConnectedSSE.call(
                this,
                data.conn_id,
                data.feed?.feed_id
              );
              userDataStore.refreshUserAccount(true);
              resolve(data);
              firebaseUtils.logClickEvent("create_generate", {
                tab_stare: "regenerate",
                mode: pitem?.mode == 1 ? "1" : pitem?.mode == 0 ? "2" : pitem?.mode?.toString() ?? '',
                musicid: data.feed?.feed_id,
                result: 0,
              });
              this.checkCreateRouter(false, "create", true);
            } else {
              this.curGenerateFeedCount -= 1;
              this.checkGenerateError({
                res,
                mode: pitem?.mode == 1 ? "1" : pitem?.mode == 0 ? "2" : pitem?.mode?.toString() ?? '',
                membership_source1: "membership_feature",
                membership_source2: "regenerate",
                tab_stare: "regenerate",
              });
              this.generating = this.getIsGenerating();
              reject("feedCardGenerate failed");
            }
          })
          .catch((err) => {
            this.curGenerateFeedCount -= 1;
            firebaseUtils.logClickEvent("create_generate", {
              tab_stare: "regenerate",
              result: 2,
              mode: pitem?.mode == 1 ? "1" : pitem?.mode == 0 ? "2" : pitem?.mode?.toString() ?? '',
            });
            this.generating = this.getIsGenerating();
            reject(err);
            message.error({
              position: "top",
              content: $$t("create.generate_failed"),
            });
          });
      });
    },
    doEditSongDoneReGenerate(pitem, item, params) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      params.start_milliseconds = Math.max(
        0,
        Math.min(item.duration_milliseconds, params.start_milliseconds)
      );

      const userDataStore = useUserDataStore();
      const draftDataStore = useDraftDataStore();
      console.log("doEditSongDoneReGenerate", pitem, item, params);
      return new Promise((resolve, reject) => {
        // if (this.generating) {
        //   message.info({
        //     position: "top",
        //     content: $$t("create.has_song_generating"),
        //   });
        //   reject($$t("create.has_song_generating"));
        //   return;
        // }
        if (this.getIsMaxQueueGeneration("doEditSongDoneReGenerate")) {
          reject("max queue generation");
          return;
        }

        this.curGenerateFeedCount += 1;
        this.generating = true;
        feedListApi
          .feedCardEditedReGenerate(params)
          .then((res) => {
            const { data, code, msg } = res;
            if (code == 200) {
              userDataStore.refreshUserAccount(true);
              this.last_generate_call_conn_id = data.conn_id;
              draftDataStore.updateFeedId(data.new_id);
              this.insertGenerateCard(data.feed, false, {
                with_thinking_process: data.with_thinking_process
              });
              this.generating = this.getIsGenerating();
              this.doGenerateConnectedSSE.call(
                this,
                data.conn_id,
                data.feed?.feed_id
              );
              firebaseUtils.logClickEvent("create_generate", {
                tab_stare: "region_editing_old",
                result: 0,
                musicid: data.feed?.feed_id,
                mode: pitem?.mode == 1 ? "1" : pitem?.mode == 0 ? "2" : pitem?.mode?.toString() ?? '',
              });
              this.checkCreateRouter(false, "create", true);
              resolve(data);
            } else {
              this.curGenerateFeedCount -= 1;
              this.checkGenerateError({
                res,
                mode: pitem?.mode == 1 ? "1" : pitem?.mode == 0 ? "2" : pitem?.mode?.toString() ?? '',
                membership_source1: "membership_feature",
                membership_source2: "regenerate",
                tab_stare: "region_editing_old",
              });
              this.generating = this.getIsGenerating();
              reject("feedCard Generate failed");
            }
          })
          .catch((err) => {
            this.curGenerateFeedCount -= 1;
            firebaseUtils.logClickEvent("create_generate", {
              tab_stare: "region_editing_old",
              result: 2,
              mode: pitem?.mode == 1 ? "1" : pitem?.mode == 0 ? "2" : pitem?.mode?.toString() ?? '',
            });
            this.generating = this.getIsGenerating();
            message.error({
              position: "top",
              content: $$t("create.generate_failed"),
            });
            reject(err);
          });
      });
    },
    doExtendDoneReGenerate(pitem, item, params) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      params.start_milliseconds = Math.max(
        0,
        Math.max(
          0,
          Math.min(item.duration_milliseconds, params.start_milliseconds) -
          (globalConfig.appname == chinaAppName ? 5000 : 0)
        )
      );
      const userDataStore = useUserDataStore();
      const draftDataStore = useDraftDataStore();
      return new Promise((resolve, reject) => {
        // if (this.generating) {
        //   message.info({
        //     position: "top",
        //     content: $$t("create.has_song_generating"),
        //   });
        //   reject($$t("create.has_song_generating"));
        //   return;
        // }
        if (this.getIsMaxQueueGeneration("doExtendDoneReGenerate")) {
          reject("max queue generation");
          return;
        }
        this.curGenerateFeedCount += 1;
        this.generating = true;
        feedListApi
          .feedCardEditedReGenerate(params)
          .then((res) => {
            const { data, code, msg } = res;
            if (code == 200) {
              userDataStore.refreshUserAccount(true);
              this.last_generate_call_conn_id = data.conn_id;
              draftDataStore.updateFeedId(data.new_id);
              this.insertGenerateCard(data.feed, false, {
                with_thinking_process: data.with_thinking_process
              });
              this.generating = this.getIsGenerating();
              this.doGenerateConnectedSSE.call(
                this,
                data.conn_id,
                data.feed?.feed_id
              );
              firebaseUtils.logClickEvent("create_generate", {
                tab_stare: "extend_old",
                result: 0,
                musicid: data.feed?.feed_id,
                mode: pitem?.mode == 1 ? "1" : pitem?.mode == 0 ? "2" : pitem?.mode?.toString() ?? '',
              });
              this.checkCreateRouter(false, "create", true);
              resolve(data);
            } else {
              this.curGenerateFeedCount -= 1;
              this.checkGenerateError({
                res,
                mode: pitem?.mode == 1 ? "1" : pitem?.mode == 0 ? "2" : pitem?.mode?.toString() ?? '',
                membership_source1: "membership_feature",
                membership_source2: "extend",
                tab_stare: "extend_old",
              });
              this.generating = this.getIsGenerating();
              reject("feedCard Generate failed");
            }
          })
          .catch((err) => {
            this.curGenerateFeedCount -= 1;
            firebaseUtils.logClickEvent("create_generate", {
              tab_stare: "extend_old",
              result: 2,
              mode: pitem?.mode == 1 ? "1" : pitem?.mode == 0 ? "2" : pitem?.mode?.toString() ?? '',
            });
            this.generating = this.getIsGenerating();
            message.error({
              position: "top",
              content: $$t("create.generate_failed"),
            });
            reject(err);
          });
      });
    },
    doReginEditSongDoneReGenerate(params, membership_source) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      const userDataStore = useUserDataStore();
      const draftDataStore = useDraftDataStore();
      return new Promise((resolve, reject) => {
        // if (this.generating) {
        //   message.info({
        //     position: "top",
        //     content: $$t("create.has_song_generating"),
        //   });
        //   reject($$t("create.has_song_generating"));
        //   return;
        // }
        if (this.getIsMaxQueueGeneration("doReginEditSongDoneReGenerate")) {
          reject("max queue generation");
          return;
        }

        this.curGenerateFeedCount += 1;
        this.generating = true;
        feedListApi
          .feedCardEditedReGenerate(params)
          .then((res) => {
            const { data, code, msg } = res;
            if (code == 200) {
              userDataStore.refreshUserAccount(true);
              this.last_generate_call_conn_id = data.conn_id;
              draftDataStore.updateFeedId(data.new_id);
              this.insertGenerateCard(data.feed, false, {
                with_thinking_process: data.with_thinking_process
              });
              this.generating = this.getIsGenerating();
              this.doGenerateConnectedSSE.call(
                this,
                data.conn_id,
                data.feed?.feed_id
              );
              firebaseUtils.logClickEvent("create_generate", {
                tab_stare: "region_editing",
                result: 0,
                musicid: data.feed?.feed_id,
              });
              this.checkCreateRouter(false, "editor", true);
              resolve(data);
            } else {
              this.curGenerateFeedCount -= 1;
              this.checkGenerateError({
                type: "region_editing",
                res,
                membership_source1: "editor",
                membership_source2: "region_editing",
                ...membership_source,
                tab_stare: "region_editing",
              });
              this.generating = this.getIsGenerating();
              reject("feedCard Generate failed");
            }
          })
          .catch((err) => {
            this.curGenerateFeedCount -= 1;
            this.generating = this.getIsGenerating();
            firebaseUtils.logClickEvent("create_generate", {
              tab_stare: "region_editing",
              result: 2,
            });
            message.error({
              position: "top",
              content: $$t("create.generate_failed"),
            });
            reject(err);
          });
      });
    },
    doExtendEditSongDoneReGenerate(params, membership_source) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      const userDataStore = useUserDataStore();
      const draftDataStore = useDraftDataStore();
      return new Promise((resolve, reject) => {
        // if (this.generating) {
        //   message.info({
        //     position: "top",
        //     content: $$t("create.has_song_generating"),
        //   });
        //   reject($$t("create.has_song_generating"));
        //   return;
        // }
        if (this.getIsMaxQueueGeneration("doExtendEditSongDoneReGenerate")) {
          reject("max queue generation");
          return;
        }
        this.curGenerateFeedCount += 1;
        this.generating = true;
        feedListApi
          .feedCardEditedReGenerate(params)
          .then((res) => {
            const { data, code, msg } = res;
            if (code == 200) {
              userDataStore.refreshUserAccount(true);
              this.last_generate_call_conn_id = data.conn_id;
              draftDataStore.updateFeedId(data.new_id);
              this.insertGenerateCard(data.feed, false, {
                with_thinking_process: data.with_thinking_process
              });
              this.generating = this.getIsGenerating();
              this.doGenerateConnectedSSE.call(
                this,
                data.conn_id,
                data.feed?.feed_id
              );
              firebaseUtils.logClickEvent("create_generate", {
                tab_stare: "extend",
                result: 0,
                musicid: data.feed?.feed_id,
              });
              this.checkCreateRouter(false, "editor", true);
              resolve(data);
            } else {
              this.curGenerateFeedCount -= 1;
              this.checkGenerateError({
                type: "extend_editing",
                res,
                mode: "2",
                membership_source1: "editor",
                membership_source2: "extend",
                ...membership_source,
                tab_stare: "extend",
              });
              this.generating = this.getIsGenerating();
              reject("feedCard Generate failed");
            }
          })
          .catch((err) => {
            this.curGenerateFeedCount -= 1;
            this.generating = this.getIsGenerating();
            message.error({
              position: "top",
              content: $$t("create.generate_failed"),
            });
            firebaseUtils.logClickEvent("create_generate", {
              tab_stare: "extend",
              result: 2,
            });
            reject(err);
          });
      });
    },
    doCoverVoiceSongDoneReGenerate(params, membership_source) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      const userDataStore = useUserDataStore();
      const draftDataStore = useDraftDataStore();
      return new Promise((resolve, reject) => {
        // if (this.generating) {
        //   message.info({
        //     position: "top",
        //     content: $$t("create.has_song_generating"),
        //   });
        //   reject($$t("create.has_song_generating"));
        //   return;
        // }
        if (this.getIsMaxQueueGeneration("doCoverVoiceSongDoneReGenerate")) {
          reject("max queue generation");
          return;
        }
        this.curGenerateFeedCount += 1;
        this.generating = true;
        feedListApi
          .feedCardCoverVoiceGenerate(params)
          .then((res) => {
            const { data, code, msg } = res;
            if (code == 200) {
              userDataStore.refreshUserAccount(true);
              this.last_generate_call_conn_id = data.conn_id;
              draftDataStore.updateFeedId(data.new_id);
              this.insertGenerateCard(data.feed, false, {
                with_thinking_process: data.with_thinking_process
              });
              this.generating = this.getIsGenerating();
              this.doGenerateConnectedSSE.call(
                this,
                data.conn_id,
                data.feed?.feed_id
              );
              firebaseUtils.logClickEvent("create_generate", {
                tab_stare: "cover_voice",
                result: 0,
                musicid: data.feed?.feed_id,
              });
              this.checkCreateRouter(false, "editor", true);
              resolve(data);
            } else {
              this.curGenerateFeedCount -= 1;
              this.checkGenerateError({
                type: "cover_voice",
                res,
                mode: "2",
                membership_source1: "editor",
                membership_source2: "cover_voice",
                ...membership_source,
                tab_stare: "cover_voice",
              });
              this.generating = this.getIsGenerating();
              reject("feedCard Generate failed");
            }
          })
          .catch((err) => {
            this.curGenerateFeedCount -= 1;
            this.generating = this.getIsGenerating();
            message.error({
              position: "top",
              content: $$t("create.generate_failed"),
            });
            firebaseUtils.logClickEvent("create_generate", {
              tab_stare: "cover_voice",
              result: 2,
            });
            reject(err);
          });
      });
    },
    doLyricTranslatorSongDoneReGenerate(params, membership_source) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      const userDataStore = useUserDataStore();
      const draftDataStore = useDraftDataStore();
      return new Promise((resolve, reject) => {
        // if (this.generating) {
        //   message.info({
        //     position: "top",
        //     content: $$t("create.has_song_generating"),
        //   });
        //   reject($$t("create.has_song_generating"));
        //   return;
        // }
        if (
          this.getIsMaxQueueGeneration("doLyricTranslatorSongDoneReGenerate")
        ) {
          reject("max queue generation");
          return;
        }
        this.curGenerateFeedCount += 1;
        this.generating = true;
        editorApi
          .translatedGenerate(params)
          .then((res) => {
            const { data, code, msg } = res;
            if (code == 200) {
              userDataStore.refreshUserAccount(true);
              this.last_generate_call_conn_id = data.conn_id;
              draftDataStore.updateFeedId(data.new_id);
              this.insertGenerateCard(data.feed, false, {
                with_thinking_process: data.with_thinking_process
              });
              this.generating = this.getIsGenerating();
              this.doGenerateConnectedSSE.call(
                this,
                data.conn_id,
                data.feed?.feed_id
              );
              firebaseUtils.logClickEvent("create_generate", {
                tab_stare: "lyrics_translate",
                result: 0,
                musicid: data.feed?.feed_id,
              });
              this.checkCreateRouter(false, "editor", true);
              resolve(data);
            } else {
              this.curGenerateFeedCount -= 1;
              this.checkGenerateError({
                type: "lyrics_translate",
                res,
                mode: "2",
                membership_source1: "editor",
                membership_source2: "lyrics_translate",
                ...membership_source,
                tab_stare: "lyrics_translate",
              });
              this.generating = this.getIsGenerating();
              reject("feedCard Generate failed");
            }
          })
          .catch((err) => {
            this.curGenerateFeedCount -= 1;
            this.generating = this.getIsGenerating();
            firebaseUtils.logClickEvent("create_generate", {
              tab_stare: "lyrics_translate",
              result: 2,
            });
            message.error({
              position: "top",
              content: $$t("create.generate_failed"),
            });
            reject(err);
          });
      });
    },
    doTrimEditSongDoneReGenerate(params, membership_source) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      const userDataStore = useUserDataStore();
      const draftDataStore = useDraftDataStore();
      return new Promise((resolve, reject) => {
        // if (this.generating) {
        //   message.info({
        //     position: "top",
        //     content: $$t("create.has_song_generating"),
        //   });
        //   reject($$t("create.has_song_generating"));
        //   return;
        // }
        if (this.getIsMaxQueueGeneration("doTrimEditSongDoneReGenerate")) {
          reject("max queue generation");
          return;
        }
        this.curGenerateFeedCount += 1;
        this.generating = true;
        feedListApi
          .feedTrimEditedReGenerate(params)
          .then((res) => {
            const { data, code, msg } = res;
            if (code == 200) {
              userDataStore.refreshUserAccount(true);
              this.last_generate_call_conn_id = data.conn_id;
              draftDataStore.updateFeedId(data.new_id);
              this.insertGenerateCard(data, true, {
                with_thinking_process: data.with_thinking_process
              });
              this.generating = this.getIsGenerating();
              this.doGenerateConnectedSSE.call(
                this,
                data.conn_id,
                data?.feed_id
              );
              firebaseUtils.logClickEvent("create_generate", {
                tab_stare: "trim_editing",
                result: 0,
                musicid: data.feed?.feed_id,
              });
              this.checkCreateRouter(false, "editor", false);
              resolve(data);
            } else {
              this.curGenerateFeedCount -= 1;
              this.checkGenerateError({
                type: "trim_editing",
                res,
                mode: "2",
                membership_source1: "editor",
                membership_source2: "trim_editing",
                ...membership_source,
                tab_stare: "trim_editing",
              });
              this.generating = this.getIsGenerating();
              reject("feedCard Generate failed");
            }
          })
          .catch((err) => {
            this.curGenerateFeedCount -= 1;
            this.generating = this.getIsGenerating();
            firebaseUtils.logClickEvent("create_generate", {
              tab_stare: "trim_editing",
              result: 0,
            });
            message.error({
              position: "top",
              content: $$t("create.generate_failed"),
            });
            reject(err);
          });
      });
    },
    reGenerateSmItem() { },
    doExtend(pitem, item) { },
    doFrom(pitem, item) { },
    doRetryGenerate(pitem, item) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      const userDataStore = useUserDataStore();
      const draftDataStore = useDraftDataStore();
      return new Promise((resolve, reject) => {
        // if (this.generating) {
        //   message.info({
        //     position: "top",
        //     content: $$t("create.has_song_generating"),
        //   });
        //   reject("has song generating");
        //   return;
        // }
        if (this.getIsMaxQueueGeneration("doRetryGenerate")) {
          reject("max queue generation");
          return;
        }
        this.curGenerateFeedCount += 1;
        this.generating = true;
        feedListApi
          .feedCardRetryGenerate({
            feed_id: pitem.feed_id,
          })
          .then((res) => {
            const { data, code, msg } = res;
            if (code == 200) {
              userDataStore.refreshUserAccount(true);
              this.last_generate_call_conn_id = data.conn_id;
              this.updateGenerateCard(data.feed);
              this.generating = this.getIsGenerating();
              this.doGenerateConnectedSSE.call(
                this,
                data.conn_id,
                data.feed?.feed_id
              );
              firebaseUtils.logClickEvent("create_generate", {
                tab_stare: "retry_generate",
                result: 0,
                musicid: data.feed?.feed_id,
                mode: pitem?.mode == 1 ? "1" : pitem?.mode == 0 ? "2" : pitem?.mode?.toString() ?? '',
              });
              resolve(data);
            } else {
              this.curGenerateFeedCount -= 1;
              this.checkGenerateError({
                res,
                mode: pitem?.mode == 1 ? "1" : pitem?.mode == 0 ? "2" : pitem?.mode?.toString() ?? '',
                membership_source1: "membership_feature",
                membership_source2: "regenerate",
                tab_stare: "retry_generate",
              });
              this.generating = this.getIsGenerating();
              reject("feedCard Generate failed");
            }
          })
          .catch((err) => {
            this.curGenerateFeedCount -= 1;
            firebaseUtils.logClickEvent("create_generate", {
              tab_stare: "retry_generate",
              result: 2,
              mode: pitem?.mode == 1 ? "1" : pitem?.mode == 0 ? "2" : pitem?.mode?.toString() ?? '',
            });
            this.generating = this.getIsGenerating();
            message.error({
              position: "top",
              content: $$t("create.generate_failed"),
            });
            reject(err);
          });
      });
    },
    doCancelGenerate(pitem, item) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      const userDataStore = useUserDataStore();
      return new Promise((resolve, reject) => {
        showActionDialog({
          // title: "Title",
          content: $$t("create.cancel_generating_alert"),
          confirmLabel: $$t("create.confirm"),
          cancelLabel: $$t("create.cancel"),
          confirm: (closeAction) => {
            closeAction();
            feedListApi
              .feedCardCancelGenerate({
                feed_id: pitem.feed_id,
              })
              .then((res) => {
                if (res.code == 200) {
                  if (this.curGenerateFeedIdList.includes(pitem?.feed_id)) {
                    this.sseGeneratingMap[pitem.feed_id]?.abort();
                    delete this.sseGeneratingMap[pitem.feed_id];
                    this.curGenerateFeedIdList.splice(
                      this.curGenerateFeedIdList.indexOf(pitem.feed_id),
                      1
                    );
                    this.curGenerateFeedCount -= 1;
                    this.generating = this.getIsGenerating();
                    if (this.initGenerateFeedData?.feed_id == pitem.feed_id) {
                      this.initGenerateFeedData = null;
                    }
                  }
                  let index = this.feedlist_createdresult.findIndex(
                    (itemF) => itemF.feed_id == pitem.feed_id
                  );
                  if (index > -1) {
                    this.feedlist_createdresult.splice(index, 1);
                    this.feedlist_createdresult = [].concat(
                      this.feedlist_createdresult
                    );
                    resolve();
                  }
                  userDataStore.refreshUserAccount(true);
                } else {
                  message.error({
                    position: "top",
                    content: $$t("create.cancel_generating_failed"),
                  });
                  reject("feedCard Cancel Generate failed");
                }
              })
              .catch((err) => {
                message.error({
                  position: "top",
                  content: $$t("create.cancel_generating_failed"),
                });
                reject(err);
              });
          },
          cancel: (closeAction) => {
            closeAction();
            reject("User canceled");
          },
        });
      });
    },
    doDeleteGenerate(pitem, item) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      return new Promise((resolve, reject) => {
        // showActionDialog({
        //   // title: "Title",
        //   content: "Are you sure you want to remove the generation?",
        //   confirm: (closeAction) => {
        //     closeAction();
        feedListApi
          .feedCardDeleteGenerate({
            feed_id: pitem.feed_id,
          })
          .then((res) => {
            if (res.code == 200) {
              if (this.curGenerateFeedId == pitem?.feed_id) {
                this.curGenerateFeedId = null;
                this.sseGenerating?.abort();
                this.generating = this.getIsGenerating();
                this.initGenerateFeedData = null;
              }
              let index = this.feedlist_createdresult.findIndex(
                (itemF) => itemF.feed_id == pitem.feed_id
              );
              if (index > -1) {
                this.feedlist_createdresult.splice(index, 1);
                this.feedlist_createdresult = [].concat(
                  this.feedlist_createdresult
                );
                resolve();
              }
            } else {
              message.error({
                position: "top",
                content: $$t("create.cancel_generating_failed"),
              });
              reject("feedCard Cancel Generate failed");
            }
          })
          .catch((err) => {
            message.error({
              position: "top",
              content: $$t("create.cancel_generating_failed"),
            });
            reject(err);
          });
        //   },
        //   cancel: (closeAction) => {
        //     closeAction();
        //     reject("User canceled");
        //   },
        // });
      });
    },
    doDelete(pitem, item) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      const globalPlayDataStore = useGlobalPlayDataStore();
      const Router = window?.$getVueCurrentInstance?.().appContext?.config?.globalProperties?.$router
      return new Promise((resolve, reject) => {
        showActionDialog({
          // title: "Title",
          content: $$t("create.remove_song_card"),
          confirmLabel: $$t("create.confirm"),
          cancelLabel: $$t("create.cancel"),
          confirm: (closeAction) => {
            closeAction();
            feedListApi
              .feedCardDelete({
                song_id: item.song_id,
              })
              .then((res) => {
                if (res.code == 200) {
                  if (["songDetail", "songDetailOld"].includes(Router.currentRoute.value?.name)) {
                    message.info({
                      position: "top",
                      content: $$t("create.song_has_been_deleted"),
                    })
                  }
                  globalPlayDataStore.removeSongItemAndSwitchNext(item);
                  for (let i = 0; i < this.TabDataSuffixLists.length; i++) {
                    const listRenderType = this.TabDataSuffixLists[i];
                    if (
                      this[`feedlist_${listRenderType}`]?.some(
                        (itemF, index) => {
                          let res = itemF.songs?.some((itemc, index) => {
                            if (itemc.song_id == item.song_id) {
                              itemF?.songs?.splice(index, 1);
                              return true;
                            }
                            return false;
                          });
                          if (!itemF?.songs?.length && ![1, 2].includes(itemF?.state)) {
                            this[`feedlist_${listRenderType}`]?.splice(index, 1);
                            i--;
                          }
                          return res;
                        }
                      )
                    ) {
                      this[`feedlist_${listRenderType}`] = [].concat(
                        this[`feedlist_${listRenderType}`]
                      );
                      this[`total_${listRenderType}`] -= 1;
                    }
                  }
                  resolve();

                } else {
                  if (res.code == 6332) {
                    message.error({
                      position: "top",
                      content: $$t("create.like_song_has_been_deleted"),
                    });
                  } else {
                    message.error({
                      position: "top",
                      content: $$t("create.remove_song_card_failed"),
                    });
                  }

                  reject("remove song card failed");
                }
              })
              .catch((err) => {
                message.error({
                  position: "top",
                  content: $$t("create.remove_song_card_failed"),
                });
                reject("remove song card failed");
              });
          },
          cancel: (closeAction) => {
            closeAction();
            reject("User canceled");
          },
        });
      });
    },
    doLike(pitem, item) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      const globalPlayDataStore = useGlobalPlayDataStore();
      const storeDetailDataStore = useStoreDetailData();
      return new Promise((resolve, reject) => {
        let state = item.is_liked == 1 ? 2 : 1;
        feedListApi
          .favoriteSong({
            song_id: item.song_id,
            state,
          })
          .then((res) => {
            if (res.code == 200) {
              item.is_liked = state;
              item.favorite_state = state;
              item.is_disliked = 2;
              for (let i = 0; i < this.TabDataSuffixLists.length; i++) {
                const listRenderType = this.TabDataSuffixLists[i];
                let index = this[`feedlist_${listRenderType}`]?.findIndex(
                  (itemF) =>
                    itemF.songs?.some((itemc) => itemc.song_id == item.song_id)
                );
                let cindex = -1;
                if (index > -1) {
                  this[`feedlist_${listRenderType}`][index].songs.forEach(
                    (itemc, indexc) => {
                      if (itemc.song_id == item.song_id) {
                        cindex = indexc;
                        itemc.is_liked = item.is_liked;
                        itemc.favorite_state = itemc.is_liked;
                        itemc.is_disliked = 2;
                      }
                    }
                  );
                  if (listRenderType == "likemysong" && cindex > -1) {
                    this[`feedlist_${listRenderType}`][index].songs.splice(
                      cindex,
                      1
                    );
                    this[`total_${listRenderType}`] -= 1;
                    if (
                      this[`feedlist_${listRenderType}`][index].songs.length ==
                      0
                    ) {
                      this[`feedlist_${listRenderType}`]?.splice(index, 1);
                    }
                  }
                  this[`feedlist_${listRenderType}`] = [].concat(
                    this[`feedlist_${listRenderType}`]
                  );
                }
              }

              storeDetailDataStore.updateSongDetail(item);
              globalPlayDataStore.updatePlayDataItem(item);
              resolve(state);
            } else if (res.code == 6332) {
              message.error({
                content: $$t("create.like_song_has_been_deleted"),
                position: "top",
              });
            } else {
              // message.error({
              //   position: "top",
              //   content: "Save failed",
              // });
              reject(res.code);
            }
          })
          .catch((err) => {
            // message.error({
            //   position: "top",
            //   content: "Save failed",
            // });
            reject(err);
          });
      });
    },
    doDislike(pitem, item) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      const globalPlayDataStore = useGlobalPlayDataStore();
      const storeDetailDataStore = useStoreDetailData();
      return new Promise((resolve, reject) => {
        let state = item.is_disliked == 1 ? 4 : 3;
        feedListApi
          .favoriteSong({
            song_id: item.song_id,
            state,
          })
          .then((res) => {
            if (res.code == 200) {
              item.is_disliked = state == 3 ? 1 : 2;
              item.is_liked = 2;
              item.favorite_state = 2;
              for (let i = 0; i < this.TabDataSuffixLists.length; i++) {
                const listRenderType = this.TabDataSuffixLists[i];
                let index = this[`feedlist_${listRenderType}`]?.findIndex(
                  (itemF) =>
                    itemF.songs?.some((itemc) => itemc.song_id == item.song_id)
                );
                let cindex = -1;
                if (index > -1) {
                  this[`feedlist_${listRenderType}`][index].songs.forEach(
                    (itemc, indexc) => {
                      if (itemc.song_id == item.song_id) {
                        cindex = indexc;
                        itemc.is_disliked = item.is_disliked;
                        itemc.is_liked = item.is_liked;
                      }
                    }
                  );
                  if (["dislikemysong", "createdresult"].includes(listRenderType) && cindex > -1) {
                    this[`feedlist_${listRenderType}`][index].songs.splice(
                      cindex,
                      1
                    );
                    this[`total_${listRenderType}`] -= 1;
                    if (
                      this[`feedlist_${listRenderType}`][index].songs.length ==
                      0
                    ) {
                      this[`feedlist_${listRenderType}`]?.splice(index, 1);
                    }
                  }
                  this[`feedlist_${listRenderType}`] = [].concat(
                    this[`feedlist_${listRenderType}`]
                  );
                }
              }

              storeDetailDataStore.updateSongDetail(item);
              globalPlayDataStore.updatePlayDataItem(item);
              resolve(item.is_disliked);
            } else if (res.code == 6332) {
              message.error({
                content: $$t("create.like_song_has_been_deleted"),
                position: "top",
              });
            } else {
              // message.error({
              //   position: "top",
              //   content: "Save failed",
              // });
              reject(res.code);
            }
          })
          .catch((err) => {
            // message.error({
            //   position: "top",
            //   content: "Save failed",
            // });
            reject(err);
          });
      });
    },
    doMore(pitem, item) { },
    doGoDetail(pitem, item, listRenderType) {
      const Router = window?.$getVueCurrentInstance?.().appContext?.config?.globalProperties?.$router
      Router.push({
        name: "songDetail",
        params: {
          song_id: item.song_id,
          from: listRenderType,
        },
        query: {
          from: listRenderType,
        },
      });
    },
    doEditSongTitle(pitem, item) {
      const globalPlayDataStore = useGlobalPlayDataStore();
      this.updateFeedSongItem(item);
      globalPlayDataStore.updatePlayDataItem(item);
    },
    showRelease(pitem, item) {
      // 首先打开发布弹窗
      this.release.showReleaseModal = true;
      this.release.pitem = pitem;
      this.release.item = item;
    },
    setTargetSongReleaseData(pitem, item, release_info) {
      const globalPlayDataStore = useGlobalPlayDataStore();
      item.release_info = release_info;
      this.updateFeedSongItem(item, true);
      globalPlayDataStore.updatePlayDataItem(item);
    },
    setReleaseData(release_info) {
      this.release.release_info = release_info;
      this.release.item = release_info.item;
      this.release.pitem = release_info.pitem;
    },
    showReleaseFormDialog() {
      // 检查歌曲发布状态，目前默认为true
      this.release.showReleaseModal = false;
      this.release.showReleaseFailModal = false;
      this.release.showReleaseFormModal = true;
    },
    showReleaseResultDialog() {
      this.release.showReleaseModal = false;
      this.release.showReleaseResultModal = true;
    },
    showReleaseAuditFailDialog(callback, reason) {
      this.release.showReleaseFailModal = true;
      this.release.failReason = reason;
      this.release.reReleaseCallback = callback;
    },
    closeReleaseDialog() {
      this.release.showReleaseModal = false;
    },
    closeReleaseFormDialog() {
      this.release.showReleaseFormModal = false;
    },
    closeReleaseResultDialog() {
      this.release.showReleaseResultModal = false;
    },
    closeReleaseFailDialog() {
      this.release.showReleaseFailModal = false;
    },
    async doRelease(data) {
      const res = await this.doUploadImage({
        changed: !!data.coverRaw?.raw,
        pathKey: data.pathKey,
        file: data.coverRaw?.raw,
        // todo: pathpay 回传
      });
      console.log(res);
      const releaseRes = await releaseSong({
        // 1-保存 2-提交发行
        song_id: this.release.item.song_id,
        submit_action: data.submitAction,
        release_info: {
          cover: res.pathKey,
          title: data.songTitle,
          description: data.desc,
          lyricist: data.lyricist,
          composer: data.composer,
          artist_name: data.artistName,
          platform_links: data.personalLinks,
        },
      });
      console.log(releaseRes);
      return releaseRes;
      // 检查歌曲发布状态，目前默认为true
    },
    doShare(pitem, item) {
      const pinia = getActivePinia()
      const { $$language } = pinia?.$i18n ?? {}
      return new Promise((resolve, reject) => {
        tools
          .copyToClipboard(
            `${globalConfig.baseOrigin}${($$language() == 'en' || globalConfig.appname == chinaAppName) ? '' : `/${$$language()}`}/song-detail/${item.share_key}?is_from_share=1`
          )
          .then((res) => {
            // message.success({
            //   content: "Song link copied",
            //   position: "top",
            // });
            resolve();
          })
          .catch(() => {
            reject("Copy failed");
          });
        feedListApi.shareSongReport({
          song_id: item.song_id,
          channel: "link",
        });
        // .then((res) => {
        //   if (res.code == 200) {
        //     resolve();
        //   } else {
        //     reject("share report failed");
        //   }
        // })
        // .catch((err) => {
        //   reject("share report failed");
        // });
      });
    },
    doSureSoldOut(pitem, item) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      let closeMsg = message.loading({
        position: "center",
        content: $$t("create.success"),
      });
      const globalPlayDataStore = useGlobalPlayDataStore();
      return new Promise((resolve, reject) => {
        feedListApi
          .saleManageSong({
            song_id: item.song_id,
            type: 0,
          })
          .then((res) => {
            closeMsg && closeMsg.clear();
            if (res.code == 200) {
              item.state = 0;
              this.updateFeedSongItem(item, true);
              globalPlayDataStore.updatePlayDataItem(item);
              resolve();
              message.success({
                position: "top",
                content: $$t("create.save_success"),
              });
            } else {
              let machine_audit_state = null;
              if (res.code == 6314) {
                machine_audit_state = 2;
                message.info({
                  position: "top",
                  content: $$t("create.song_state_auditing"),
                });
                reject("song state auditing");
              } else if (res.code == 6315) {
                machine_audit_state = 4;
                message.info({
                  position: "top",
                  content: $$t("create.song_state_auditing_failed_disabled"),
                });
                reject("song state auditing failed");
                this.updateFeedSongItem({
                  song_id: item.song_id,
                  machine_audit_state,
                });
              } else {
                message.error({
                  position: "top",
                  content: $$t("create.save_failed"),
                });
                reject("save failed");
              }
            }
          })
          .catch((err) => {
            closeMsg && closeMsg.clear();

            message.error({
              position: "top",
              content: $$t("create.save_failed"),
            });
            reject(err);
          });
      });
    },
    doUploadImage(imageData, callbackUploadDatal) {
      return new Promise(async (resolve, reject) => {
        if (!imageData.changed && imageData.pathKey) {
          resolve({
            pathKey: imageData.pathKey,
            fullUrl: getObjectStorageFullUrl(imageData.pathKey),
          });
          return;
        }
        try {
          const objectStorageRes =
            await objectStorage.uploadFileToObjectStorage(
              imageData.file,
              (obj) => {
                callbackUploadDatal?.(obj);
              }
            );
          resolve(objectStorageRes);
        } catch (e) {
          reject(e);
        }
      });
    },
    doSureCancelPublish(pitem, item) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      return new Promise((resolve, reject) => {
        const globalPlayDataStore = useGlobalPlayDataStore();
        const storeDetailDataStore = useStoreDetailData();
        showActionDialog({
          hideCancel: false,
          content: $$t("create.action_unpblish"),
          confirmLabel: $$t("create.unpublish"),
          confirm: (closeAction) => {
            let closeMsg = message.loading({
              position: "center",
              content: $$t("create.applying"),
            });
            feedListApi
              .feedSongPublish({
                song_id: item.song_id,
                type: 2,
              })
              .then((res) => {
                closeMsg && closeMsg.clear();
                if (res.code == 200) {
                  message.error({
                    content: $$t("create.song_unpublish_success"),
                    position: "top",
                  });

                  for (let i = 0; i < this.TabDataSuffixLists.length; i++) {
                    const listRenderType = this.TabDataSuffixLists[i];
                    let cindex = -1;
                    let index = this[`feedlist_${listRenderType}`]?.findIndex(
                      (itemF) =>
                        itemF.songs?.some((itemc, indexC) => {
                          if (itemc.song_id == item.song_id) {
                            itemc.publish_state = res.data?.publish_state ?? 2;
                            cindex = indexC;
                            return true;
                          }
                        })
                    );
                    if (index > -1) {
                      if (listRenderType == "publishedmysong" && cindex > -1) {
                        this[`feedlist_${listRenderType}`][index].songs?.splice(
                          cindex,
                          1
                        );
                        this[`total_${listRenderType}`] -= 1;
                        if (
                          !this[`feedlist_${listRenderType}`][index].songs
                            ?.length
                        ) {
                          this[`feedlist_${listRenderType}`]?.splice(index, 1);
                        }
                      }
                      this[`feedlist_${listRenderType}`] = [].concat(
                        this[`feedlist_${listRenderType}`]
                      );
                    }
                  }
                  item.publish_state = res.data?.publish_state ?? 2;
                  storeDetailDataStore.updateSongDetail(item);
                  globalPlayDataStore.updatePlayDataItem(item);
                  resolve();
                } else {
                  message.info({
                    position: "top",
                    content: $$t("create.song_unpublish_failed"),
                  });
                }
              })
              .catch((err) => {
                closeMsg && closeMsg.clear();
                message.error({
                  content: $$t("create.song_unpublish_failed"),
                  position: "top",
                });
                reject(err);
              });
            closeAction();
          },
          cancel(closeAction) {
            reject("cancel");
            closeAction();
          },
        });
      });
    },
    doSureToSaveSongInfo(pitem, item, imageData, params = {}) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      return new Promise((resolve, reject) => {
        const globalPlayDataStore = useGlobalPlayDataStore();
        const storeDetailDataStore = useStoreDetailData();
        let closeMsg = message.loading({
          position: "center",
          content: $$t("create.applying"),
        });
        this.doUploadImage(imageData).then((uploadRes) => {
          feedListApi
            .savefeedSongInfo({
              ...params,
              cover: uploadRes?.pathKey,
            })
            .then((res) => {
              closeMsg && closeMsg.clear();
              if (res.code == 200) {
                message.error({
                  content: $$t("create.save_success"),
                  position: "top",
                });

                item.cover = uploadRes?.pathKey;
                item.title = params.title;
                this.updateFeedSongItem(item, true);
                globalPlayDataStore.updatePlayDataItem(item);
                storeDetailDataStore.updateSongDetail(item);
                resolve();
              } else {
                let machine_audit_state = null;
                if (res.code == 6314) {
                  machine_audit_state = 2;
                } else if (res.code == 6315) {
                  machine_audit_state = 4;
                  message.info({
                    position: "top",
                    content: $$t("create.song_state_auditing_failed_disabled"),
                  });
                  this.updateFeedSongItem({
                    song_id: item.song_id,
                    machine_audit_state,
                  });
                } else if (res.code == 6121) {
                  message.error({
                    position: "top",
                    content: $$t("create.process_song_info"),
                  });
                } else if (res.code == 6320) {
                  message.error({
                    position: "top",
                    content: $$t("create.song_cover_auditing_failed"),
                  });
                } else if (res.code == 6316) {
                  message.error({
                    position: "top",
                    content: $$t("create.song_title_audit_failed"),
                  });
                } else if (res.code == 6330) {
                  message.error({
                    position: "top",
                    content: $$t("create.published_song_not_modify"),
                  });
                } else {
                  message.error({
                    content: $$t("create.save_failed"),
                    position: "top",
                  });
                }
                reject("publish failed");
              }
            })
            .catch((err) => {
              closeMsg && closeMsg.clear();
              message.error({
                content: $$t("create.save_failed"),
                position: "top",
              });
              reject(err);
            });
        }).catch((err) => {
          closeMsg && closeMsg.clear();
          message.error({
            content: $$t("create.save_failed"),
            position: "top",
          });
          reject(err);
        });
      });
    },
    doSureToPublish(pitem, item, imageData, params = {}) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      return new Promise((resolve, reject) => {
        const globalPlayDataStore = useGlobalPlayDataStore();
        let closeMsg = message.loading({
          position: "center",
          content: $$t("create.publishing"),
        });
        this.doUploadImage(imageData).then((uploadRes) => {
          feedListApi
            .feedSongPublish({
              ...params,
              cover: uploadRes?.pathKey,
            })
            .then((res) => {
              closeMsg && closeMsg.clear();
              if (res.code == 200) {
                message.error({
                  content: $$t("create.song_publish_success"),
                  position: "top",
                });
                item.publish_state = res.data?.publish_state ?? 1;
                item.cover = uploadRes?.pathKey;
                item.title = params.title;
                item.moods = params.moods;
                item.genres = params.genres;
                this.updateFeedSongItem(item, true);
                globalPlayDataStore.updatePlayDataItem(item);
                resolve();
              } else {
                let machine_audit_state = null;
                if (res.code == 6314) {
                  machine_audit_state = 2;
                } else if (res.code == 6315) {
                  machine_audit_state = 4;
                  message.info({
                    position: "top",
                    content: $$t("create.song_state_auditing_failed_disabled"),
                  });
                  this.updateFeedSongItem({
                    song_id: item.song_id,
                    machine_audit_state,
                  });
                } else if (res.code == 6320) {
                  message.error({
                    position: "top",
                    content: $$t("create.song_cover_auditing_failed"),
                  });
                } else if (res.code == 6316) {
                  message.error({
                    position: "top",
                    content: $$t("create.song_title_audit_failed"),
                  });
                } else if (res.code == 6121) {
                  message.error({
                    position: "top",
                    content: $$t("create.process_song_info"),
                  });
                } else {
                  message.error({
                    content: $$t("create.song_publish_failed"),
                    position: "top",
                  });
                }
                reject("publish failed");
              }
            })
            .catch((err) => {
              closeMsg && closeMsg.clear();
              message.error({
                content: $$t("create.song_publish_failed"),
                position: "top",
              });
              reject(err);
            });
        });
      });
    },
    doSureSale(pitem, item, params = {}) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      const globalPlayDataStore = useGlobalPlayDataStore();
      let closeMsg = message.loading({
        position: "center",
        content: $$t("create.applying"),
      });
      return new Promise((resolve, reject) => {
        feedListApi
          .saleManageSong({
            song_id: item.song_id,
            ...params,
            type: item.state == 3 ? 2 : 1,
          })
          .then((res) => {
            if (res.code == 200) {
              item.state = res.data?.state ?? 1;
              this.updateFeedSongItem(item, true);
              globalPlayDataStore.updatePlayDataItem(item);
              resolve();
              closeMsg && closeMsg.clear();
              message.success({
                position: "top",
                content: $$t("create.song_sale_under_review"),
              });
            } else {
              closeMsg && closeMsg.clear();
              let machine_audit_state = null;
              if (res.code == 6314) {
                machine_audit_state = 2;
              } else if (res.code == 6315) {
                machine_audit_state = 4;
                message.info({
                  position: "top",
                  content: $$t("create.song_state_auditing_failed_disabled"),
                });
                this.updateFeedSongItem({
                  song_id: item.song_id,
                  machine_audit_state,
                });
              } else if (res.code == 6121) {
                message.error({
                  position: "top",
                  content: $$t("create.process_song_info"),
                });
              } else {
                message.error({
                  position: "top",
                  content: $$t("create.applying_failed"),
                });
              }
              reject("sale failed");
            }
          })
          .catch((err) => {
            closeMsg && closeMsg.clear();
            message.error({
              position: "top",
              content: $$t("create.applying_failed"),
            });
            reject(err);
          });
      });
    },
    doDownloadAuto(pitem, item) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      message.error({
        position: "top",
        content: $$t("create.downloading_wait"),
      });
      const userDataStore = useUserDataStore();
      return new Promise((resolve, reject) => {
        feedListApi
          .feedCardDownloadQuery({
            song_id: item.song_id,
            t: 2,
          })
          .then((res) => {
            let machine_audit_state = null;
            if (res.code == 6314) {
              machine_audit_state = 2;
              message.info({
                position: "top",
                content: $$t("create.song_state_auditing"),
              });
              reject("song state auditing");
            } else if (res.code == 6315) {
              machine_audit_state = 4;
              message.info({
                position: "top",
                content: $$t("create.song_state_auditing_failed_disabled"),
              });
              this.updateFeedSongItem({
                song_id: item.song_id,
                machine_audit_state,
              });
              reject("song state auditing failed");
            } else if (res.code == 6335) {
              message.error({
                content: $$t("editor.subscripe_level_not_met"),
                position: "top",
              });
              reject("subscripe level not met");
            } else if (res.code == 200) {
              userDataStore.refreshUserAccount(true);
              tools
                .downLoadAtag({
                  useAlink: true,
                  href: item.mp3_url,
                  fileName:
                    item.title.replace(/(\s+)|(\n+)/g, "_") +
                    "." +
                    tools.getFileExtension(href),
                })
                .then((res) => {
                  // message.success({
                  //   content: $$t("create.download_success"),
                  //   position: "top",
                  // });
                });
              resolve();
            } else if (res.data.paid_state == 3) {
              message.error({
                position: "top",
                content: $$t("create.credits_not_enough"),
              });
              reject("credits not enough");
            } else {
              message.error({
                position: "top",
                content: $$t("create.downloading_failed"),
              });
              reject("downloading failed");
            }
          })
          .catch((err) => {
            message.error({
              position: "top",
              content: $$t("create.downloading_failed"),
            });

            reject(err);
          });
      });
    },
    doDownloadMp3(pitem, item) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      message.info({
        position: "top",
        content: $$t("create.downloading_wait"),
      });
      const userDataStore = useUserDataStore();
      return new Promise((resolve, reject) => {
        feedListApi
          .feedCardDownloadQuery({
            song_id: item.song_id,
            t: 1,
          })
          .then((res) => {
            let machine_audit_state = null;
            if (res.code == 6314) {
              machine_audit_state = 2;
              message.info({
                position: "top",
                content: $$t("create.song_state_auditing"),
              });
              reject("song state auditing");
            } else if (res.code === 6124) {
              message.error({
                content: $$t("create.only_vip_can_download"),
                position: "top",
              });
            } else if (res.code == 6315) {
              machine_audit_state = 4;
              message.info({
                position: "top",
                content: $$t("create.song_state_auditing_failed_disabled"),
              });
              reject("song state auditing failed");
              this.updateFeedSongItem({
                song_id: item.song_id,
                machine_audit_state,
              });
            } else if (res.code == 6335) {
              message.error({
                content: $$t("editor.subscripe_level_not_met"),
                position: "top",
              });
              reject("subscripe level not met");
            } else if (res.code == 200) {
              userDataStore.refreshUserAccount(true);
              tools
                .downLoadAtag({
                  useAlink: true,
                  href: getObjectStorageFullUrl(res.data.oss_key),
                  fileName:
                    item.title.replace(/(\s+)|(\n+)/g, "_") +
                    "." +
                    tools.getFileExtension(res.data.oss_key),
                })
                .then((res) => {
                  // message.success({
                  //   position: "top",
                  //   content: $$t("create.download_success"),
                  // });
                  resolve();
                })
                .catch((err) => {
                  reject(MediaError);
                });
            } else {
              message.error({
                position: "top",
                content: $$t("create.downloading_failed"),
              });
              reject("downloading failed");
            }
          })
          .catch((err) => {
            message.error({
              position: "top",
              content: $$t("create.downloading_failed"),
            });

            reject("downloading failed");
          });
      });
    },
    doDownloadExtendMp3(pitem, item) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      message.info({
        position: "top",
        content: $$t("create.downloading_wait"),
      });
      const userDataStore = useUserDataStore();
      return new Promise((resolve, reject) => {
        feedListApi
          .feedCardDownloadQuery({
            song_id: item.song_id,
            t: 6,
          })
          .then((res) => {
            let machine_audit_state = null;
            if (res.code == 6314) {
              machine_audit_state = 2;
              message.info({
                position: "top",
                content: $$t("create.song_state_auditing"),
              });
              reject("song state auditing");
            } else if (res.code === 6124) {
              message.error({
                content: $$t("create.only_vip_can_download"),
                position: "top",
              });
            } else if (res.code == 6315) {
              machine_audit_state = 4;
              message.info({
                position: "top",
                content: $$t("create.song_state_auditing_failed_disabled"),
              });
              reject("song state auditing failed");
              this.updateFeedSongItem({
                song_id: item.song_id,
                machine_audit_state,
              });
            } else if (res.code == 6335) {
              message.error({
                content: $$t("editor.subscripe_level_not_met"),
                position: "top",
              });
              reject("subscripe level not met");
            } else if (res.code == 200) {
              userDataStore.refreshUserAccount(true);
              tools
                .downLoadAtag({
                  useAlink: true,
                  href: getObjectStorageFullUrl(res.data.oss_key),
                  fileName:
                    item.title.replace(/(\s+)|(\n+)/g, "_") +
                    "." +
                    tools.getFileExtension(res.data.oss_key),
                })
                .then((res) => {
                  // message.success({
                  //   position: "top",
                  //   content: $$t("create.download_success"),
                  // });
                  resolve();
                })
                .catch((err) => {
                  reject(MediaError);
                });
            } else {
              message.error({
                position: "top",
                content: $$t("create.downloading_failed"),
              });
              reject("downloading failed");
            }
          })
          .catch((err) => {
            message.error({
              position: "top",
              content: $$t("create.downloading_failed"),
            });

            reject("downloading failed");
          });
      });
    },
    doDownloadCopyright(pitem, item) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      message.info({
        position: "top",
        content: $$t("create.downloading_wait"),
      });
      const userDataStore = useUserDataStore();
      return new Promise((resolve, reject) => {
        feedListApi
          .feedCardDownloadQuery({
            song_id: item.song_id,
            t: 5,
          })
          .then((res) => {
            if (res.code == 6314) {
              machine_audit_state = 2;
              message.info({
                position: "top",
                content: $$t("create.song_state_auditing"),
              });
              reject("song state auditing");
            } else if (res.code === 6124) {
              message.error({
                content: $$t("create.only_vip_can_download"),
                position: "top",
              });
            } else if (res.code == 6315) {
              machine_audit_state = 4;
              message.info({
                position: "top",
                content: $$t("create.song_state_auditing_failed_disabled"),
              });
              reject("song state auditing failed");
              this.updateFeedSongItem({
                song_id: item.song_id,
                machine_audit_state,
              });
            } else if (res.code == 6335) {
              message.error({
                content: $$t("editor.subscripe_level_not_met"),
                position: "top",
              });
              reject("subscripe level not met");
            } else if (res.code == 200) {
              userDataStore.refreshUserAccount(true);
              tools
                .downLoadAtag({
                  useAlink: true,
                  href: getObjectStorageFullUrl(res.data.oss_key),
                  fileName:
                    $$t("create.ownership_certificate") +
                    "." +
                    tools.getFileExtension(res.data.oss_key),
                })
                .then((res) => {
                  // message.success({
                  //   position: "top",
                  //   content: $$t("create.download_success"),
                  // });
                });
              resolve();
            } else {
              message.error({
                position: "top",
                content: $$t("create.downloading_failed"),
              });
              reject("downloading failed");
            }
          })
          .catch((err) => {
            message.error({
              position: "top",
              content: $$t("create.downloading_failed"),
            });
            reject("downloading failed");
          });
      });
    },
    doDownloadSongAllData(pitem, item) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      message.info({
        position: "top",
        content: $$t("create.stem_audio_processing"),
      });
      const userDataStore = useUserDataStore();
      return new Promise((resolve, reject) => {
        feedListApi
          .feedCardDownloadQuery(
            {
              song_id: item.song_id,
              t: 2,
            },
            {
              timeout: 1000 * 60 * 5,
            }
          )
          .then((res) => {
            if (res.code == 6314) {
              machine_audit_state = 2;
              message.info({
                position: "top",
                content: $$t("create.song_state_auditing"),
              });
              reject("song state auditing");
            } else if (res.code === 6124) {
              message.error({
                content: $$t("create.only_vip_can_download"),
                position: "top",
              });
            } else if (res.code == 6315) {
              machine_audit_state = 4;
              message.info({
                position: "top",
                content: $$t("create.song_state_auditing_failed_disabled"),
              });
              reject("song state auditing failed");
              this.updateFeedSongItem({
                song_id: item.song_id,
                machine_audit_state,
              });
            } else if (res.code == 6335) {
              message.error({
                content: $$t("editor.subscripe_level_not_met"),
                position: "top",
              });
              reject("subscripe level not met");
            } else if (res.code == 200) {
              userDataStore.refreshUserAccount(true);
              if (!res.data.oss_key) {
                message.error({
                  position: "top",
                  content: $$t("create.stem_audio_processing_failed"),
                });
                reject(false);
              } else if (res.data?.paid_state == 1 || !res.data?.paid_state) {
                message.info({
                  position: "top",
                  content: $$t("create.downloading_stem_audio"),
                });
                tools
                  .downLoadAtag({
                    useAlink: true,
                    href: getObjectStorageFullUrl(res.data.oss_key),
                    fileName:
                      item.title.replace(/(\s+)|(\n+)/g, "_") +
                      "." +
                      tools.getFileExtension(res.data.oss_key),
                  })
                  .then((res) => {
                    resolve();
                    // message.success({
                    //   position: "top",
                    //   content: $$t("create.download_success"),
                    // });
                  })
                  .catch((err) => {
                    reject(false);
                  });
              } else if (res.data?.paid_state == 2) {
                this.goCredits(null, {
                  membership_source1: "membership_feature",
                  membership_source2: "download_instrumental_stem",
                });
                reject(false);
              } else {
                message.error({
                  position: "top",
                  content: $$t("create.stem_audio_processing_failed"),
                });
                reject(false);
              }
            } else {
              message.error({
                position: "top",
                content: $$t("create.stem_audio_processing_failed"),
              });
              reject(false);
            }
          })
          .catch((err) => {
            message.error({
              position: "top",
              content: $$t("create.downloading_failed"),
            });

            reject(err);
          });
      });
    },

    doDownloadVideo(pitem, item, is_download) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      message.info({
        position: "top",
        content: $$t("create.downloading_video_wait"),
      });
      const userDataStore = useUserDataStore();
      return new Promise((resolve, reject) => {
        feedListApi
          .feedCardGetDownloadVideo({
            song_id: item.song_id,
            is_download,
            // t: 1,
          })
          .then((res) => {
            if (res.code == 6334) {
              message.error({
                position: "top",
                content: res.msg,
              });
              reject("song state auditing failed");
            } else if (res.code == 6335) {
              message.error({
                content: $$t("editor.subscripe_level_not_met"),
                position: "top",
              });
              reject("subscripe level not met");
            } else if (res.code == 200) {
              if (!is_download) {
                resolve(res.data.video_url);
                return;
              }
              userDataStore.refreshUserAccount(true);
              tools
                .downLoadAtag({
                  useAlink: true,
                  href: getObjectStorageFullUrl(res.data.video_url),
                  fileName:
                    item.title.replace(/(\s+)|(\n+)/g, "_") +
                    "." +
                    tools.getFileExtension(res.data.video_url),
                })
                .then((res) => {
                  // message.success({
                  //   position: "top",
                  //   content: $$t("create.download_success"),
                  // });
                  resolve();
                })
                .catch((err) => {
                  reject(MediaError);
                });
            } else {
              message.error({
                position: "top",
                content: $$t("create.downloading_failed"),
              });
              reject("downloading failed");
            }
          })
          .catch((err) => {
            message.error({
              position: "top",
              content: $$t("create.downloading_failed"),
            });

            reject("downloading failed");
          });
      });
    },
    doAddPlayList(pitem, item, listRenderType) {
      const globalPlayDataStore = useGlobalPlayDataStore();
      const userDataStore = useUserDataStore();
      globalPlayDataStore.setCurPlayGroup(`feedlist_${listRenderType}`);

      let datas = this[`feedlist_${listRenderType}`]?.reduce((res, cur) => {
        if (cur.songs?.length) {
          cur.songs.forEach((item) => {
            Object.assign(item, {
              ...item,
              favorite_state: item.is_liked,
              uid: userDataStore?.authData?.user_id,
            });
            if (!item.recall) {
              res = res.concat(item);
            }
          });
          return res;
        }
        return res;
      }, []);
      item.favorite_state = item.is_liked;
      globalPlayDataStore.setPlayDatas(datas, item);
      // globalPlayDataStore.addPlayDatas(datas);
      globalPlayDataStore.setCurPlayData(item);
    },
    doTogglePlay(pitem, item, isPlay, listRenderType) {
      const globalPlayDataStore = useGlobalPlayDataStore();
      const userDataStore = useUserDataStore();
      globalPlayDataStore.setCurPlayGroup(`feedlist_${listRenderType}`);

      let datas = this[`feedlist_${listRenderType}`]?.reduce((res, cur) => {
        if (cur.songs?.length) {
          cur.songs.forEach((item) => {
            Object.assign(item, {
              ...item,
              favorite_state: item.is_liked,
              uid: userDataStore?.authData?.user_id,
            });
            if (!item.recall) {
              res = res.concat(item);
            }
          });
          return res;
        }
        return res;
      }, []);
      item.favorite_state = item.is_liked;
      globalPlayDataStore.setPlayDatas(datas, item);
    },
    addFeedDataToPlayList(datas, listRenderType) {
      const globalPlayDataStore = useGlobalPlayDataStore();
      if (globalPlayDataStore.curPlayGroup != `feedlist_${listRenderType}`) {
        return;
      }
      let addDatas = datas.reduce((res, cur) => {
        if (cur.songs?.length) {
          cur.songs.forEach((item) => {
            Object.assign(item, {
              ...item,
              favorite_state: item.is_liked,
            });
            if (!item.recall) {
              res = res.concat(item);
            }
          });
        }
        return res;
      }, []);
      globalPlayDataStore.addPlayDatas(addDatas);
    },
    doReportPlayedState(pitem, item) {
      const userDataStore = useUserDataStore();
      return new Promise((resolve, reject) => {
        if (!userDataStore.isLogin) {
          reject("login failed");
          return;
        }
        feedListApi
          .doReportPlayedState({
            song_id: item.song_id,
          })
          .then((res) => {
            if (res.code == 200) {
              this.updateFeedSongItem(
                {
                  ...item,
                  song_id: item.song_id,
                  is_played: true,
                },
                true
              );
              resolve();
            } else {
              reject(res?.msg ?? "save failed");
            }
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    doPlayStateReport(pitem, item, play_type) {
      return new Promise((resolve, reject) => {
        feedListApi
          .doPlayStateReport({
            song_id: item?.song_id,
            play_type: play_type,
          })
          .then((res) => {
            if (res.code == 200) {
              resolve();
              this.updateFeedSongItem(
                {
                  ...item,
                  song_id: item.song_id,
                  is_played: true,
                },
                true
              );
            } else {
              reject(res?.msg ?? "save failed");
            }
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
  },
});
export default useFeedListStore;
// export const feedlistStore = useFeedListStore()
